
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * This file is a collection of strings used to store values
 * in the tram-one global space. If you ever need to debug Tram-One's
 * internal state, you can inspect these on the window.
 *
 * e.g. `window['tram-space']['tram-hook-key']`
 */ const $2e682f50ad48c6fc$var$TRAM_HOOK_KEY = 'tram-hook-key';
const $2e682f50ad48c6fc$var$TRAM_EFFECT_STORE = 'tram-effect-store';
const $2e682f50ad48c6fc$var$TRAM_EFFECT_QUEUE = 'tram-effect-queue';
const $2e682f50ad48c6fc$var$TRAM_KEY_STORE = 'tram-key-store';
const $2e682f50ad48c6fc$var$TRAM_KEY_QUEUE = 'tram-key-queue';
const $2e682f50ad48c6fc$var$TRAM_GLOBAL_KEY_QUEUE = 'tram-global-key-queue';
const $2e682f50ad48c6fc$var$TRAM_OBSERVABLE_STORE = 'tram-observable-store';
const $2e682f50ad48c6fc$var$TRAM_MUTATION_OBSERVER = 'tram-mutation-observer';
/*
 * namespace is a generic interface for global tram-one state that needs
 * to be persisted in the app container. It exposes a setup and get function.
 */ const $2e682f50ad48c6fc$var$getTramWindow = ()=>{
    // if tram-one is setup it will have a defined value in the 'tram-space'
    const tramOneIsSetup = window['tram-space'];
    // otherwise, we should warn
    // this usually happens when calling a hook outside of a component function
    // but this could be potentially triggered other ways - if we find those, we should broaden the message then
    if (!tramOneIsSetup) throw new Error(`
			Tram-One: app has not started yet, but hook was called. Is it being invoked outside a component function?
			https://github.com/Tram-One/tram-one/issues/178
		`);
    return window;
};
const $2e682f50ad48c6fc$var$setupTramOneSpace = ()=>{
    window['tram-space'] = {};
};
const $2e682f50ad48c6fc$var$buildNamespace = (constructor)=>{
    const setup = (namespace)=>{
        const tramWindow = $2e682f50ad48c6fc$var$getTramWindow();
        tramWindow['tram-space'][namespace] = constructor();
        return tramWindow['tram-space'][namespace];
    };
    const get = (namespace)=>{
        const tramWindow = $2e682f50ad48c6fc$var$getTramWindow();
        return tramWindow['tram-space'][namespace];
    };
    const set = (namespace, value)=>{
        const tramWindow = $2e682f50ad48c6fc$var$getTramWindow();
        tramWindow['tram-space'][namespace] = value;
    };
    return {
        setup: setup,
        get: get,
        set: set
    };
};
/*
 * This file defines all the functions required to interact with
 * a working-key object. This working-key object is used to help
 * hooks understand where in the mounting process we are, and what
 * values or effects to pull / trigger.
 */ const $2e682f50ad48c6fc$var$defaultWorkingKey = ()=>({
        // list of custom tags that we've stepped into
        branch: [],
        // map of branches to index value (used as a cursor for hooks)
        branchIndices: {
            '': 0
        }
    });
const { setup: $2e682f50ad48c6fc$var$setupWorkingKey, get: $2e682f50ad48c6fc$var$getWorkingKey } = $2e682f50ad48c6fc$var$buildNamespace($2e682f50ad48c6fc$var$defaultWorkingKey);
const $2e682f50ad48c6fc$var$getWorkingBranch = (keyName)=>{
    const workingkeyObject = $2e682f50ad48c6fc$var$getWorkingKey(keyName);
    return workingkeyObject.branch.join('/');
};
/**
 * push a new branch value, usually when we step into a new
 * custom component when mounting.
 */ const $2e682f50ad48c6fc$var$pushWorkingKeyBranch = (keyName, branch)=>{
    const workingKey = $2e682f50ad48c6fc$var$getWorkingKey(keyName);
    workingKey.branch.push(branch);
    if (!workingKey.branchIndices[$2e682f50ad48c6fc$var$getWorkingBranch(keyName)]) workingKey.branchIndices[$2e682f50ad48c6fc$var$getWorkingBranch(keyName)] = 0;
};
/**
 * pops the current branch value, usually when we are done mounting
 * a single child component.
 */ const $2e682f50ad48c6fc$var$popWorkingKeyBranch = (keyName)=>{
    const workingKey = $2e682f50ad48c6fc$var$getWorkingKey(keyName);
    workingKey.branch.pop();
};
/**
 * increments the value for the current branch.
 * These values are used to pull the correct hook value on re-renders.
 */ const $2e682f50ad48c6fc$var$incrementWorkingKeyBranch = (keyName)=>{
    const workingKey = $2e682f50ad48c6fc$var$getWorkingKey(keyName);
    workingKey.branchIndices[$2e682f50ad48c6fc$var$getWorkingBranch(keyName)] += 1;
};
/**
 * used to get a unique string that will be used as a key for observables and effects.
 * This unique string _should_ be consistent over many re-renders.
 */ const $2e682f50ad48c6fc$var$getWorkingKeyValue = (keyName)=>{
    const workingKey = $2e682f50ad48c6fc$var$getWorkingKey(keyName);
    const index = workingKey.branchIndices[$2e682f50ad48c6fc$var$getWorkingBranch(keyName)];
    return `${$2e682f50ad48c6fc$var$getWorkingBranch(keyName)}[${index}]`;
};
/**
 * returns a deep copy of the existing key, usually used as a restore point later
 */ const $2e682f50ad48c6fc$var$copyWorkingKey = (keyName)=>{
    const key = $2e682f50ad48c6fc$var$getWorkingKey(keyName);
    return {
        branch: [
            ...key.branch
        ],
        branchIndices: {
            ...key.branchIndices
        }
    };
};
/**
 * if we needed to reset pre-emptively, use this to get back
 * to where the branches were before
 */ const $2e682f50ad48c6fc$var$restoreWorkingKey = (keyName, restoreKey)=>{
    const key = $2e682f50ad48c6fc$var$getWorkingKey(keyName);
    const branches = key.branchIndices;
    key.branch = [
        ...restoreKey.branch
    ];
    const resetBranchValue = (branch)=>{
        branches[branch] = restoreKey.branchIndices[branch] || 0;
    };
    Object.keys(key.branchIndices).forEach(resetBranchValue);
};
/*
 * This file is a collection of strings used to store values
 * in custom elements. If you ever need to debug Tram-One's
 * internal state, you can inspect these on individual elements.
 *
 * e.g. `$0['tram-hook-key']`
 */ const $2e682f50ad48c6fc$var$TRAM_TAG = 'tram-tag';
const $2e682f50ad48c6fc$var$TRAM_TAG_REACTION = 'tram-tag-reaction';
const $2e682f50ad48c6fc$var$TRAM_TAG_STORE_KEYS = 'tram-tag-store-keys';
const $2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS = 'tram-tag-new-effects';
const $2e682f50ad48c6fc$var$TRAM_TAG_CLEANUP_EFFECTS = 'tram-tag-cleanup-effects';
// Debug properties used for tram-one dev tools
const $2e682f50ad48c6fc$var$TRAM_TAG_NAME = 'tram-tag-name';
const $2e682f50ad48c6fc$var$TRAM_TAG_PROPS = 'tram-tag-props';
const $2e682f50ad48c6fc$var$TRAM_TAG_CHILDREN = 'tram-tag-children';
const $2e682f50ad48c6fc$var$TRAM_TAG_GLOBAL_STORE_KEYS = 'tram-tag-global-store-keys';
var $1682bfda3685e13f$var$connectionStore = new WeakMap();
var $1682bfda3685e13f$var$ITERATION_KEY = Symbol('iteration key');
function $1682bfda3685e13f$var$storeObservable(obj) {
    // this will be used to save (obj.key -> reaction) connections later
    $1682bfda3685e13f$var$connectionStore.set(obj, new Map());
}
function $1682bfda3685e13f$var$registerReactionForOperation(reaction, ref) {
    var target = ref.target;
    var key = ref.key;
    var type = ref.type;
    if (type === 'iterate') key = $1682bfda3685e13f$var$ITERATION_KEY;
    var reactionsForObj = $1682bfda3685e13f$var$connectionStore.get(target);
    var reactionsForKey = reactionsForObj.get(key);
    if (!reactionsForKey) {
        reactionsForKey = new Set();
        reactionsForObj.set(key, reactionsForKey);
    }
    // save the fact that the key is used by the reaction during its current run
    if (!reactionsForKey.has(reaction)) {
        reactionsForKey.add(reaction);
        reaction.cleaners.push(reactionsForKey);
    }
}
function $1682bfda3685e13f$var$getReactionsForOperation(ref) {
    var target = ref.target;
    var key = ref.key;
    var type = ref.type;
    var reactionsForTarget = $1682bfda3685e13f$var$connectionStore.get(target);
    var reactionsForKey = new Set();
    if (type === 'clear') reactionsForTarget.forEach(function(_, key) {
        $1682bfda3685e13f$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key);
    });
    else $1682bfda3685e13f$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key);
    if (type === 'add' || type === 'delete' || type === 'clear') {
        var iterationKey = Array.isArray(target) ? 'length' : $1682bfda3685e13f$var$ITERATION_KEY;
        $1682bfda3685e13f$var$addReactionsForKey(reactionsForKey, reactionsForTarget, iterationKey);
    }
    return reactionsForKey;
}
function $1682bfda3685e13f$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key) {
    var reactions = reactionsForTarget.get(key);
    reactions && reactions.forEach(reactionsForKey.add, reactionsForKey);
}
function $1682bfda3685e13f$var$releaseReaction(reaction) {
    if (reaction.cleaners) reaction.cleaners.forEach($1682bfda3685e13f$var$releaseReactionKeyConnection, reaction);
    reaction.cleaners = [];
}
function $1682bfda3685e13f$var$releaseReactionKeyConnection(reactionsForKey) {
    reactionsForKey.delete(this);
}
// reactions can call each other and form a call stack
var $1682bfda3685e13f$var$reactionStack = [];
var $1682bfda3685e13f$var$isDebugging = false;
function $1682bfda3685e13f$var$runAsReaction(reaction, fn, context, args) {
    // do not build reactive relations, if the reaction is unobserved
    if (reaction.unobserved) return Reflect.apply(fn, context, args);
    // only run the reaction if it is not already in the reaction stack
    // TODO: improve this to allow explicitly recursive reactions
    if ($1682bfda3685e13f$var$reactionStack.indexOf(reaction) === -1) {
        // release the (obj -> key -> reactions) connections
        // and reset the cleaner connections
        $1682bfda3685e13f$var$releaseReaction(reaction);
        try {
            // set the reaction as the currently running one
            // this is required so that we can create (observable.prop -> reaction) pairs in the get trap
            $1682bfda3685e13f$var$reactionStack.push(reaction);
            return Reflect.apply(fn, context, args);
        } finally{
            // always remove the currently running flag from the reaction when it stops execution
            $1682bfda3685e13f$var$reactionStack.pop();
        }
    }
}
// register the currently running reaction to be queued again on obj.key mutations
function $1682bfda3685e13f$var$registerRunningReactionForOperation(operation) {
    // get the current reaction from the top of the stack
    var runningReaction = $1682bfda3685e13f$var$reactionStack[$1682bfda3685e13f$var$reactionStack.length - 1];
    if (runningReaction) {
        $1682bfda3685e13f$var$debugOperation(runningReaction, operation);
        $1682bfda3685e13f$var$registerReactionForOperation(runningReaction, operation);
    }
}
function $1682bfda3685e13f$var$queueReactionsForOperation(operation) {
    // iterate and queue every reaction, which is triggered by obj.key mutation
    $1682bfda3685e13f$var$getReactionsForOperation(operation).forEach($1682bfda3685e13f$var$queueReaction, operation);
}
function $1682bfda3685e13f$var$queueReaction(reaction) {
    $1682bfda3685e13f$var$debugOperation(reaction, this);
    // queue the reaction for later execution or run it immediately
    if (typeof reaction.scheduler === 'function') reaction.scheduler(reaction);
    else if (typeof reaction.scheduler === 'object') reaction.scheduler.add(reaction);
    else reaction();
}
function $1682bfda3685e13f$var$debugOperation(reaction, operation) {
    if (reaction.debugger && !$1682bfda3685e13f$var$isDebugging) try {
        $1682bfda3685e13f$var$isDebugging = true;
        reaction.debugger(operation);
    } finally{
        $1682bfda3685e13f$var$isDebugging = false;
    }
}
function $1682bfda3685e13f$var$hasRunningReaction() {
    return $1682bfda3685e13f$var$reactionStack.length > 0;
}
var $1682bfda3685e13f$var$IS_REACTION = Symbol('is reaction');
function $1682bfda3685e13f$export$d1203567a167490e(fn, options) {
    if (options === void 0) options = {};
    // wrap the passed function in a reaction, if it is not already one
    var reaction = fn[$1682bfda3685e13f$var$IS_REACTION] ? fn : function reaction() {
        return $1682bfda3685e13f$var$runAsReaction(reaction, fn, this, arguments);
    };
    // save the scheduler and debugger on the reaction
    reaction.scheduler = options.scheduler;
    reaction.debugger = options.debugger;
    // save the fact that this is a reaction
    reaction[$1682bfda3685e13f$var$IS_REACTION] = true;
    // run the reaction once if it is not a lazy one
    if (!options.lazy) reaction();
    return reaction;
}
function $1682bfda3685e13f$export$23a2283368c55ea2(reaction) {
    // do nothing, if the reaction is already unobserved
    if (!reaction.unobserved) {
        // indicate that the reaction should not be triggered any more
        reaction.unobserved = true;
        // release (obj -> key -> reaction) connections
        $1682bfda3685e13f$var$releaseReaction(reaction);
    }
    // unschedule the reaction, if it is scheduled
    if (typeof reaction.scheduler === 'object') reaction.scheduler.delete(reaction);
}
var $1682bfda3685e13f$var$proxyToRaw = new WeakMap();
var $1682bfda3685e13f$var$rawToProxy = new WeakMap();
var $1682bfda3685e13f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $1682bfda3685e13f$var$findObservable(obj) {
    var observableObj = $1682bfda3685e13f$var$rawToProxy.get(obj);
    if ($1682bfda3685e13f$var$hasRunningReaction() && typeof obj === 'object' && obj !== null) {
        if (observableObj) return observableObj;
        return $1682bfda3685e13f$export$5ab46cbf6120b33a(obj);
    }
    return observableObj || obj;
}
function $1682bfda3685e13f$var$patchIterator(iterator, isEntries) {
    var originalNext = iterator.next;
    iterator.next = function() {
        var ref = originalNext.call(iterator);
        var done = ref.done;
        var value = ref.value;
        if (!done) {
            if (isEntries) value[1] = $1682bfda3685e13f$var$findObservable(value[1]);
            else value = $1682bfda3685e13f$var$findObservable(value);
        }
        return {
            done: done,
            value: value
        };
    };
    return iterator;
}
var $1682bfda3685e13f$var$instrumentations = {
    has: function has(key) {
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $1682bfda3685e13f$var$registerRunningReactionForOperation({
            target: target,
            key: key,
            type: 'has'
        });
        return proto.has.apply(target, arguments);
    },
    get: function get(key) {
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $1682bfda3685e13f$var$registerRunningReactionForOperation({
            target: target,
            key: key,
            type: 'get'
        });
        return $1682bfda3685e13f$var$findObservable(proto.get.apply(target, arguments));
    },
    add: function add(key) {
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        // forward the operation before queueing reactions
        var result = proto.add.apply(target, arguments);
        if (!hadKey) $1682bfda3685e13f$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: key,
            type: 'add'
        });
        return result;
    },
    set: function set(key, value) {
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        var oldValue = proto.get.call(target, key);
        // forward the operation before queueing reactions
        var result = proto.set.apply(target, arguments);
        if (!hadKey) $1682bfda3685e13f$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: value,
            type: 'add'
        });
        else if (value !== oldValue) $1682bfda3685e13f$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: value,
            oldValue: oldValue,
            type: 'set'
        });
        return result;
    },
    delete: function delete$1(key) {
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        var oldValue = proto.get ? proto.get.call(target, key) : undefined;
        // forward the operation before queueing reactions
        var result = proto.delete.apply(target, arguments);
        if (hadKey) $1682bfda3685e13f$var$queueReactionsForOperation({
            target: target,
            key: key,
            oldValue: oldValue,
            type: 'delete'
        });
        return result;
    },
    clear: function clear() {
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadItems = target.size !== 0;
        var oldTarget = target instanceof Map ? new Map(target) : new Set(target);
        // forward the operation before queueing reactions
        var result = proto.clear.apply(target, arguments);
        if (hadItems) $1682bfda3685e13f$var$queueReactionsForOperation({
            target: target,
            oldTarget: oldTarget,
            type: 'clear'
        });
        return result;
    },
    forEach: function forEach(cb) {
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $1682bfda3685e13f$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        // swap out the raw values with their observable pairs
        // before passing them to the callback
        var wrappedCb = function(value) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            return cb.apply(void 0, [
                $1682bfda3685e13f$var$findObservable(value)
            ].concat(rest));
        };
        var ref;
        return (ref = proto.forEach).call.apply(ref, [
            target,
            wrappedCb
        ].concat(args));
    },
    keys: function keys() {
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $1682bfda3685e13f$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        return proto.keys.apply(target, arguments);
    },
    values: function values() {
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $1682bfda3685e13f$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        var iterator = proto.values.apply(target, arguments);
        return $1682bfda3685e13f$var$patchIterator(iterator, false);
    },
    entries: function entries() {
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $1682bfda3685e13f$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        var iterator = proto.entries.apply(target, arguments);
        return $1682bfda3685e13f$var$patchIterator(iterator, true);
    },
    get size () {
        var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $1682bfda3685e13f$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        return Reflect.get(proto, 'size', target);
    }
};
$1682bfda3685e13f$var$instrumentations[Symbol.iterator] = function() {
    var target = $1682bfda3685e13f$var$proxyToRaw.get(this);
    var proto = Reflect.getPrototypeOf(this);
    $1682bfda3685e13f$var$registerRunningReactionForOperation({
        target: target,
        type: 'iterate'
    });
    var iterator = proto[Symbol.iterator].apply(target, arguments);
    return $1682bfda3685e13f$var$patchIterator(iterator, target instanceof Map);
};
var $1682bfda3685e13f$var$collectionHandlers = {
    get: function get(target, key, receiver) {
        // instrument methods and property accessors to be reactive
        target = $1682bfda3685e13f$var$hasOwnProperty.call($1682bfda3685e13f$var$instrumentations, key) ? $1682bfda3685e13f$var$instrumentations : target;
        return Reflect.get(target, key, receiver);
    }
};
// eslint-disable-next-line
var $1682bfda3685e13f$var$globalObj = typeof window === 'object' ? window : Function('return this')();
// built-in object can not be wrapped by Proxies
// their methods expect the object instance as the 'this' instead of the Proxy wrapper
// complex objects are wrapped with a Proxy of instrumented methods
// which switch the proxy to the raw object and to add reactive wiring
var $1682bfda3685e13f$var$handlers = new Map([
    [
        Map,
        $1682bfda3685e13f$var$collectionHandlers
    ],
    [
        Set,
        $1682bfda3685e13f$var$collectionHandlers
    ],
    [
        WeakMap,
        $1682bfda3685e13f$var$collectionHandlers
    ],
    [
        WeakSet,
        $1682bfda3685e13f$var$collectionHandlers
    ],
    [
        Object,
        false
    ],
    [
        Array,
        false
    ],
    [
        Int8Array,
        false
    ],
    [
        Uint8Array,
        false
    ],
    [
        Uint8ClampedArray,
        false
    ],
    [
        Int16Array,
        false
    ],
    [
        Uint16Array,
        false
    ],
    [
        Int32Array,
        false
    ],
    [
        Uint32Array,
        false
    ],
    [
        Float32Array,
        false
    ],
    [
        Float64Array,
        false
    ]
]);
function $1682bfda3685e13f$var$shouldInstrument(ref) {
    var constructor = ref.constructor;
    var isBuiltIn = typeof constructor === 'function' && constructor.name in $1682bfda3685e13f$var$globalObj && $1682bfda3685e13f$var$globalObj[constructor.name] === constructor;
    return !isBuiltIn || $1682bfda3685e13f$var$handlers.has(constructor);
}
function $1682bfda3685e13f$var$getHandlers(obj) {
    return $1682bfda3685e13f$var$handlers.get(obj.constructor);
}
var $1682bfda3685e13f$var$hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var $1682bfda3685e13f$var$wellKnownSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function(key) {
    return Symbol[key];
}).filter(function(value) {
    return typeof value === 'symbol';
}));
// intercept get operations on observables to know which reaction uses their properties
function $1682bfda3685e13f$var$get(target, key, receiver) {
    var result = Reflect.get(target, key, receiver);
    // do not register (observable.prop -> reaction) pairs for well known symbols
    // these symbols are frequently retrieved in low level JavaScript under the hood
    if (typeof key === 'symbol' && $1682bfda3685e13f$var$wellKnownSymbols.has(key)) return result;
    // register and save (observable.prop -> runningReaction)
    $1682bfda3685e13f$var$registerRunningReactionForOperation({
        target: target,
        key: key,
        receiver: receiver,
        type: 'get'
    });
    // if we are inside a reaction and observable.prop is an object wrap it in an observable too
    // this is needed to intercept property access on that object too (dynamic observable tree)
    var observableResult = $1682bfda3685e13f$var$rawToProxy.get(result);
    if ($1682bfda3685e13f$var$hasRunningReaction() && typeof result === 'object' && result !== null) {
        if (observableResult) return observableResult;
        // do not violate the none-configurable none-writable prop get handler invariant
        // fall back to none reactive mode in this case, instead of letting the Proxy throw a TypeError
        var descriptor = Reflect.getOwnPropertyDescriptor(target, key);
        if (!descriptor || !(descriptor.writable === false && descriptor.configurable === false)) return $1682bfda3685e13f$export$5ab46cbf6120b33a(result);
    }
    // otherwise return the observable wrapper if it is already created and cached or the raw object
    return observableResult || result;
}
function $1682bfda3685e13f$var$has(target, key) {
    var result = Reflect.has(target, key);
    // register and save (observable.prop -> runningReaction)
    $1682bfda3685e13f$var$registerRunningReactionForOperation({
        target: target,
        key: key,
        type: 'has'
    });
    return result;
}
function $1682bfda3685e13f$var$ownKeys(target) {
    $1682bfda3685e13f$var$registerRunningReactionForOperation({
        target: target,
        type: 'iterate'
    });
    return Reflect.ownKeys(target);
}
// intercept set operations on observables to know when to trigger reactions
function $1682bfda3685e13f$var$set(target, key, value, receiver) {
    // make sure to do not pollute the raw object with observables
    if (typeof value === 'object' && value !== null) value = $1682bfda3685e13f$var$proxyToRaw.get(value) || value;
    // save if the object had a descriptor for this key
    var hadKey = $1682bfda3685e13f$var$hasOwnProperty$1.call(target, key);
    // save if the value changed because of this set operation
    var oldValue = target[key];
    // execute the set operation before running any reaction
    var result = Reflect.set(target, key, value, receiver);
    // do not queue reactions if the target of the operation is not the raw receiver
    // (possible because of prototypal inheritance)
    if (target !== $1682bfda3685e13f$var$proxyToRaw.get(receiver)) return result;
    // queue a reaction if it's a new property or its value changed
    if (!hadKey) $1682bfda3685e13f$var$queueReactionsForOperation({
        target: target,
        key: key,
        value: value,
        receiver: receiver,
        type: 'add'
    });
    else if (value !== oldValue) $1682bfda3685e13f$var$queueReactionsForOperation({
        target: target,
        key: key,
        value: value,
        oldValue: oldValue,
        receiver: receiver,
        type: 'set'
    });
    return result;
}
function $1682bfda3685e13f$var$deleteProperty(target, key) {
    // save if the object had the key
    var hadKey = $1682bfda3685e13f$var$hasOwnProperty$1.call(target, key);
    var oldValue = target[key];
    // execute the delete operation before running any reaction
    var result = Reflect.deleteProperty(target, key);
    // only queue reactions for delete operations which resulted in an actual change
    if (hadKey) $1682bfda3685e13f$var$queueReactionsForOperation({
        target: target,
        key: key,
        oldValue: oldValue,
        type: 'delete'
    });
    return result;
}
var $1682bfda3685e13f$var$baseHandlers = {
    get: $1682bfda3685e13f$var$get,
    has: $1682bfda3685e13f$var$has,
    ownKeys: $1682bfda3685e13f$var$ownKeys,
    set: $1682bfda3685e13f$var$set,
    deleteProperty: $1682bfda3685e13f$var$deleteProperty
};
function $1682bfda3685e13f$export$5ab46cbf6120b33a(obj) {
    if (obj === void 0) obj = {};
    // if it is already an observable or it should not be wrapped, return it
    if ($1682bfda3685e13f$var$proxyToRaw.has(obj) || !$1682bfda3685e13f$var$shouldInstrument(obj)) return obj;
    // if it already has a cached observable wrapper, return it
    // otherwise create a new observable
    return $1682bfda3685e13f$var$rawToProxy.get(obj) || $1682bfda3685e13f$var$createObservable(obj);
}
function $1682bfda3685e13f$var$createObservable(obj) {
    // if it is a complex built-in object or a normal object, wrap it
    var handlers = $1682bfda3685e13f$var$getHandlers(obj) || $1682bfda3685e13f$var$baseHandlers;
    var observable = new Proxy(obj, handlers);
    // save these to switch between the raw object and the wrapped object with ease later
    $1682bfda3685e13f$var$rawToProxy.set(obj, observable);
    $1682bfda3685e13f$var$proxyToRaw.set(observable, obj);
    // init basic data structures to save and cleanup later (observable.prop -> reaction) connections
    $1682bfda3685e13f$var$storeObservable(obj);
    return observable;
}
function $1682bfda3685e13f$export$5cd057a6046189f9(obj) {
    return $1682bfda3685e13f$var$proxyToRaw.has(obj);
}
function $1682bfda3685e13f$export$1776c186c69df29e(obj) {
    return $1682bfda3685e13f$var$proxyToRaw.get(obj) || obj;
}


var $2e682f50ad48c6fc$require$observe$1 = $1682bfda3685e13f$export$d1203567a167490e;
// functions to go to nodes or indices (made for .map)
const $2e682f50ad48c6fc$var$toIndices = (node, index)=>index;
// sorting function that prioritizes indices that are closest to a target
// e.g. target = 3, [1, 2, 3, 4, 5] => [3, 2, 4, 1, 5]
const $2e682f50ad48c6fc$var$byDistanceFromIndex = (targetIndex)=>(indexA, indexB)=>{
        const diffFromTargetA = Math.abs(indexA - targetIndex);
        const diffFromTargetB = Math.abs(indexB - targetIndex);
        return diffFromTargetA - diffFromTargetB;
    };
const $2e682f50ad48c6fc$var$hasMatchingTagName = (tagName)=>(node)=>{
        const nodeHasMatchingTagName = 'tagName' in node && node.tagName === tagName;
        // if the tagName matches, we want to process the node, otherwise skip it
        return nodeHasMatchingTagName ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    };
// get an array including the element and all it's children
const $2e682f50ad48c6fc$var$parentAndChildrenElements = (node, tagName)=>{
    const matchesTagName = $2e682f50ad48c6fc$var$hasMatchingTagName(tagName);
    const componentWalker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT, matchesTagName);
    const parentAndChildren = [
        componentWalker.currentNode
    ];
    while(componentWalker.nextNode())parentAndChildren.push(componentWalker.currentNode);
    // since we are looking for elements (things with tagNames)
    // we can safely declare this as an array of Elements
    return parentAndChildren;
};
const $2e682f50ad48c6fc$var$defaultRemovedElementWithFocusData = {
    index: -1,
    tagName: '',
    scrollLeft: 0,
    scrollTop: 0,
    selectionStart: null,
    selectionEnd: null,
    selectionDirection: undefined
};
/**
 * This is a helper function for the dom creation.
 * This function observes any state values used when making the tag, and allow it to update
 * independently when one of those state values updates.
 *
 * The mutation-observer will unobserve any reactions here when the node is removed.
 *
 * The parameter tagFunction is almost a TramOneComponent, but it already has the props and children prepopulated,
 * and so has no parameters, but returns a TramOneElement
 */ var $2e682f50ad48c6fc$var$observeTag = (tagFunction)=>{
    let tagResult;
    const buildAndReplaceTag = ()=>{
        // if there is an existing tagResult, it is the last rendering, and so we want to re-render over it
        let oldTag = tagResult;
        let removedElementWithFocusData = $2e682f50ad48c6fc$var$defaultRemovedElementWithFocusData;
        // remove oldTag first so that we unobserve before we re-observe
        if (oldTag) {
            // we need to blow away any old focus data we had
            removedElementWithFocusData = $2e682f50ad48c6fc$var$defaultRemovedElementWithFocusData;
            // determine if this element (or any element under it) had focus
            const oldTagHasFocusedElement = oldTag.contains(document.activeElement);
            // if an element had focus, copy over all the selection data (so we can copy it back later)
            if (oldTagHasFocusedElement) {
                // we'll assume that the element is an HTMLInputElement, in reality other kinds of elements will be caught here,
                // but that's fine, since they have null as selection attributes, and setting them to null is fine
                const activeElement = document.activeElement;
                // first, we need to get all the elements that are similar (we'll use tagName)
                // this way, when we rerender, we can search for those tagNames, and just use the index we got here
                const allActiveLikeElements = $2e682f50ad48c6fc$var$parentAndChildrenElements(oldTag, activeElement.tagName);
                removedElementWithFocusData.index = allActiveLikeElements.findIndex((element)=>element === activeElement);
                // copy over the data
                removedElementWithFocusData.tagName = activeElement.tagName;
                removedElementWithFocusData.scrollLeft = activeElement.scrollLeft;
                removedElementWithFocusData.scrollTop = activeElement.scrollTop;
                removedElementWithFocusData.selectionStart = activeElement.selectionStart;
                removedElementWithFocusData.selectionEnd = activeElement.selectionEnd;
                removedElementWithFocusData.selectionDirection = activeElement.selectionDirection || undefined;
            }
            const emptyDiv = document.createElement('div');
            oldTag.replaceWith(emptyDiv);
            // copy the reaction and effects from the old tag to the empty div so we don't lose them
            emptyDiv[$2e682f50ad48c6fc$var$TRAM_TAG_REACTION] = oldTag[$2e682f50ad48c6fc$var$TRAM_TAG_REACTION];
            emptyDiv[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS] = oldTag[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS];
            emptyDiv[$2e682f50ad48c6fc$var$TRAM_TAG_CLEANUP_EFFECTS] = oldTag[$2e682f50ad48c6fc$var$TRAM_TAG_CLEANUP_EFFECTS];
            // set oldTag to emptyDiv, so we can replace it later
            oldTag = emptyDiv;
        }
        // build the component
        tagResult = tagFunction();
        // if oldTag was defined, then we need to replace it with the new result
        if (oldTag) {
            // if an element had focus, reapply it
            let elementToGiveFocus;
            if (removedElementWithFocusData.index >= 0) {
                const allActiveLikeElements = $2e682f50ad48c6fc$var$parentAndChildrenElements(tagResult, removedElementWithFocusData.tagName);
                // we'll look through the elements (in order of nodes closest to original index) and find a tag that matches.
                // this means if it didn't move, we'll get it right away,
                // if it did, we'll look at the elements closest to the original position
                const elementIndexToGiveFocus = allActiveLikeElements.map($2e682f50ad48c6fc$var$toIndices).sort($2e682f50ad48c6fc$var$byDistanceFromIndex(removedElementWithFocusData.index))[0];
                elementToGiveFocus = allActiveLikeElements[elementIndexToGiveFocus];
                // also try to set the selection, if there is a selection for this element
                try {
                    if (elementToGiveFocus.setSelectionRange !== undefined) elementToGiveFocus.setSelectionRange(removedElementWithFocusData.selectionStart, removedElementWithFocusData.selectionEnd, removedElementWithFocusData.selectionDirection);
                } catch (exception) {
                // don't worry if we fail
                // this can happen if the element has a `setSelectionRange` but it isn't supported
                // e.g. input with type="range"
                }
                elementToGiveFocus.scrollLeft = removedElementWithFocusData.scrollLeft;
                elementToGiveFocus.scrollTop = removedElementWithFocusData.scrollTop;
            }
            // don't lose track that this is still a tram-one element
            tagResult[$2e682f50ad48c6fc$var$TRAM_TAG] = true;
            // copy the reaction and effects from the old tag to the new one
            tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_REACTION] = oldTag[$2e682f50ad48c6fc$var$TRAM_TAG_REACTION];
            tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS] = oldTag[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS];
            tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_CLEANUP_EFFECTS] = oldTag[$2e682f50ad48c6fc$var$TRAM_TAG_CLEANUP_EFFECTS];
            // both these actions cause forced reflow, and can be performance issues
            oldTag.replaceWith(tagResult);
            if (elementToGiveFocus && elementToGiveFocus.focus) elementToGiveFocus.focus();
        }
    };
    const tagReaction = $2e682f50ad48c6fc$require$observe$1(buildAndReplaceTag);
    // tagResult is always assigned as an artifact of the observe() call above
    // if it isn't, we want to know about it
    if (tagResult === undefined) throw new Error(`
			Tram-One: tagResult was not defined after building the tag.
			https://github.com/Tram-One/tram-one/issues/177
		`);
    // save the reaction to the node, so that the mutation-observer can unobserve it later
    tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_REACTION] = tagReaction;
    return tagResult;
};
/*
 * EffectStores in Tram-One are used for basic key-value object mappings that need
 * to be persisted in the globalSpace.
 *
 * Currently this is used with useEffect to keep track of what
 * new effects should be triggered or cleaned up
 */ const $2e682f50ad48c6fc$var$newDefaultEffectStore = ()=>{
    return {};
};
const { setup: $2e682f50ad48c6fc$var$setupEffectStore, get: $2e682f50ad48c6fc$var$getEffectStore, set: $2e682f50ad48c6fc$var$setEffectStore } = $2e682f50ad48c6fc$var$buildNamespace($2e682f50ad48c6fc$var$newDefaultEffectStore);
/**
 * clear the effect store
 * usually called when we want to empty the effect store
 */ const $2e682f50ad48c6fc$var$clearEffectStore = (effectStoreName)=>{
    const effectStore = $2e682f50ad48c6fc$var$getEffectStore(effectStoreName);
    Object.keys(effectStore).forEach((key)=>delete effectStore[key]);
};
/**
 * restore the effect store to a previous value
 * usually used when we had to interrupt the processing of effects
 */ const $2e682f50ad48c6fc$var$restoreEffectStore = $2e682f50ad48c6fc$var$setEffectStore;
/*
 * The KeyQueue in Tram-One is a basic list of keys
 * that needs to be persisted in the globalSpace.
 *
 * Currently this is used with useStore to keep track of what
 * stores need to be associated with generated elements
 */ const $2e682f50ad48c6fc$var$newDefaultKeyQueue = ()=>{
    return [];
};
const { setup: $2e682f50ad48c6fc$var$setupKeyQueue, get: $2e682f50ad48c6fc$var$getKeyQueue, set: $2e682f50ad48c6fc$var$setKeyQueue } = $2e682f50ad48c6fc$var$buildNamespace($2e682f50ad48c6fc$var$newDefaultKeyQueue);
/**
 * clear the key queue
 * usually called when we want to empty the key queue
 */ const $2e682f50ad48c6fc$var$clearKeyQueue = (keyQueueName)=>{
    const keyQueue = $2e682f50ad48c6fc$var$getKeyQueue(keyQueueName);
    keyQueue.splice(0, keyQueue.length);
};
/**
 * restore the key queue to a previous value
 * usually used when we had to interrupt the processing of keys
 */ const $2e682f50ad48c6fc$var$restoreKeyQueue = $2e682f50ad48c6fc$var$setKeyQueue;
/**
 * This is a helper function for the dom creation.
 * This function stores any keys generated when building a tag in the resulting node that is generated.
 *
 * These are later processed by the mutation-observer, and cleaned up when the node is removed by the mutation-observer.
 *
 * This function is called every time state changes in an observable store
 */ var $2e682f50ad48c6fc$var$processHooks = (tagFunction)=>{
    // save the existing effect queue and key queue for any components we are in the middle of building
    const existingQueuedEffects = {
        ...$2e682f50ad48c6fc$var$getEffectStore($2e682f50ad48c6fc$var$TRAM_EFFECT_QUEUE)
    };
    const existingQueuedKeys = [
        ...$2e682f50ad48c6fc$var$getKeyQueue($2e682f50ad48c6fc$var$TRAM_KEY_QUEUE)
    ];
    // clear the queues (so we can get just new effects and keys)
    $2e682f50ad48c6fc$var$clearEffectStore($2e682f50ad48c6fc$var$TRAM_EFFECT_QUEUE);
    $2e682f50ad48c6fc$var$clearKeyQueue($2e682f50ad48c6fc$var$TRAM_KEY_QUEUE);
    $2e682f50ad48c6fc$var$clearKeyQueue($2e682f50ad48c6fc$var$TRAM_GLOBAL_KEY_QUEUE);
    // create the component, which will save new effects to the effect queue
    const tagResult = tagFunction();
    // see if there are any brand new effects
    const existingEffects = $2e682f50ad48c6fc$var$getEffectStore($2e682f50ad48c6fc$var$TRAM_EFFECT_STORE);
    const queuedEffects = $2e682f50ad48c6fc$var$getEffectStore($2e682f50ad48c6fc$var$TRAM_EFFECT_QUEUE);
    // pull new effects that have yet to be processed from the tag
    // these can appear when a component re-exposes another component at its root
    const existingNewEffects = tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS] || [];
    // store new effects (and the existing new effects) in the node we just built
    const newEffects = Object.keys(queuedEffects).filter((effect)=>!(effect in existingEffects));
    const newEffectFunctions = newEffects.map((newEffectKey)=>queuedEffects[newEffectKey]);
    const existingNewAndBrandNewEffects = existingNewEffects.concat(newEffectFunctions);
    tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS] = existingNewAndBrandNewEffects;
    // same as the existingNewEffects, but for state values
    const existingNewKeys = tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_STORE_KEYS] || [];
    // get all new keys
    const newKeys = $2e682f50ad48c6fc$var$getKeyQueue($2e682f50ad48c6fc$var$TRAM_KEY_QUEUE);
    // store keys in the node we just built
    const existingNewAndBrandNewKeys = existingNewKeys.concat(newKeys);
    tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_STORE_KEYS] = existingNewAndBrandNewKeys;
    // restore the effect and key queues to what they were before we started
    $2e682f50ad48c6fc$var$restoreEffectStore($2e682f50ad48c6fc$var$TRAM_EFFECT_QUEUE, existingQueuedEffects);
    $2e682f50ad48c6fc$var$restoreKeyQueue($2e682f50ad48c6fc$var$TRAM_KEY_QUEUE, existingQueuedKeys);
    return tagResult;
};
var $5912e0d8006d4e74$exports = {};
var $119bc398b8498ab5$exports = {};
const $119bc398b8498ab5$var$parseNodeAsString = (node)=>typeof node === 'number' || typeof node === 'boolean' || typeof node === 'function' || node instanceof Date || node instanceof RegExp ? node.toString() : node;
const $119bc398b8498ab5$var$isNotWhitespace = (node)=>!(typeof node === 'string' && /^[\n\r\s]+$/.test(node));
const $119bc398b8498ab5$var$appendChild = (element, childs)=>{
    if (!Array.isArray(childs)) return;
    childs.map($119bc398b8498ab5$var$parseNodeAsString).filter($119bc398b8498ab5$var$isNotWhitespace).forEach((node)=>{
        if (Array.isArray(node)) {
            $119bc398b8498ab5$var$appendChild(element, node);
            return;
        }
        if (typeof node === 'string') {
            if (element.lastChild && element.lastChild.nodeName === '#text') {
                element.lastChild.nodeValue += node;
                return;
            }
            node = document.createTextNode(node);
        }
        if (node && node.nodeType) element.appendChild(node);
    });
};
$119bc398b8498ab5$exports = $119bc398b8498ab5$var$appendChild;


const $5912e0d8006d4e74$var$COMMENT_TAG = '!--';
// filters for attributes
const $5912e0d8006d4e74$var$isNotXMLNSprop = (prop)=>!/^xmlns($|:)/i.test(prop);
const $5912e0d8006d4e74$var$containsOwnProp = (props)=>(prop)=>Object.prototype.hasOwnProperty.call(props, prop);
// map to objects so we know their value
const $5912e0d8006d4e74$var$toObjectList = (props)=>(prop)=>({
            key: prop,
            value: props[prop]
        });
// transformations for attributes
const $5912e0d8006d4e74$var$normalizeClassName = (prop)=>prop.key.toLowerCase() === 'classname' ? {
        key: 'class',
        value: prop.value
    } : prop;
const $5912e0d8006d4e74$var$htmlForToFor = (prop)=>prop.key === 'htmlFor' ? {
        key: 'for',
        value: prop.value
    } : prop;
const $5912e0d8006d4e74$var$addEventToElement = (element, eventKey, eventValue)=>{
    element[eventKey] = eventValue;
    // add event to element list of events
    element.events = element.events ? element.events.concat(eventKey) : [
        eventKey
    ];
};
// handlers that can be filtered on
// if something gets processed, we return false
// otherwise, it returns true, indicating that this thing needs to be processed
const $5912e0d8006d4e74$var$handleEventSetter = (element)=>(prop)=>prop.key.slice(0, 2) === 'on' ? $5912e0d8006d4e74$var$addEventToElement(element, prop.key, prop.value) : true;
const $5912e0d8006d4e74$var$handleAttrSetter = (element)=>(prop)=>prop.key.match(/:/) ? element.setAttribute(prop.key, prop.value) : element.setAttributeNS(null, prop.key, prop.value);
const $5912e0d8006d4e74$var$nanoCreateElement = (namespace)=>(tag, props, children)=>{
        // if the tag is a comment
        if (tag === $5912e0d8006d4e74$var$COMMENT_TAG) return document.createComment(props.comment);
        // create the element
        const element = namespace ? document.createElementNS(namespace, tag) : document.createElement(tag);
        // attach the properties
        Object.keys(props).filter($5912e0d8006d4e74$var$isNotXMLNSprop).filter($5912e0d8006d4e74$var$containsOwnProp(props)).map($5912e0d8006d4e74$var$toObjectList(props)).map($5912e0d8006d4e74$var$normalizeClassName).map($5912e0d8006d4e74$var$htmlForToFor).filter($5912e0d8006d4e74$var$handleEventSetter(element)).filter($5912e0d8006d4e74$var$handleAttrSetter(element));
        $119bc398b8498ab5$exports(element, children);
        return element;
    };
$5912e0d8006d4e74$exports = $5912e0d8006d4e74$var$nanoCreateElement;
$5912e0d8006d4e74$exports.html = $5912e0d8006d4e74$var$nanoCreateElement();
$5912e0d8006d4e74$exports.svg = $5912e0d8006d4e74$var$nanoCreateElement('http://www.w3.org/2000/svg');


var $19b97d144575daf1$exports = {};
$19b97d144575daf1$exports = function(domBuilder, h, components) {
    const eh = function(tagName, attrs, children) {
        const component = components[tagName];
        const node = component ? component(attrs, children) : h(tagName, attrs, children);
        return node;
    };
    const hx = domBuilder(eh);
    hx.h = eh;
    return hx;
};


var $bb4637dd63499816$exports = {};
var $0dc8290522203a6e$exports = {};
$0dc8290522203a6e$exports = $0dc8290522203a6e$var$attributeToProperty;
var $0dc8290522203a6e$var$transform = {
    'class': 'className',
    'for': 'htmlFor',
    'http-equiv': 'httpEquiv'
};
function $0dc8290522203a6e$var$attributeToProperty(h) {
    return function(tagName, attrs, children) {
        for(var attr in attrs)if (attr in $0dc8290522203a6e$var$transform) {
            attrs[$0dc8290522203a6e$var$transform[attr]] = attrs[attr];
            delete attrs[attr];
        }
        return h(tagName, attrs, children);
    };
}


const $bb4637dd63499816$var$VAR = 0, $bb4637dd63499816$var$TEXT = 1, $bb4637dd63499816$var$OPEN = 2, $bb4637dd63499816$var$CLOSE = 3, $bb4637dd63499816$var$ATTR = 4, $bb4637dd63499816$var$ATTR_KEY = 5, $bb4637dd63499816$var$ATTR_KEY_W = 6, $bb4637dd63499816$var$ATTR_VALUE_W = 7, $bb4637dd63499816$var$ATTR_VALUE = 8, $bb4637dd63499816$var$ATTR_VALUE_SQ = 9, $bb4637dd63499816$var$ATTR_VALUE_DQ = 10, $bb4637dd63499816$var$ATTR_EQ = 11, $bb4637dd63499816$var$ATTR_BREAK = 12, $bb4637dd63499816$var$COMMENT = 13, $bb4637dd63499816$var$SELF_CLOSE = 14;
$bb4637dd63499816$exports = function(h, opts) {
    if (!opts) opts = {
        comments: true
    };
    const concat = opts.concat || function(a, b) {
        return String(a) + String(b);
    };
    const strfn = (x)=>{
        switch(typeof x){
            case 'function':
            case 'string':
            case 'object':
            case 'undefined':
                return x;
            default:
                return concat('', x);
        }
    };
    if (opts.attrToProp !== false) h = $0dc8290522203a6e$exports(h);
    return function(strings) {
        var state = $bb4637dd63499816$var$TEXT, reg = '';
        var arglen = arguments.length;
        var parts = [];
        for(var i = 0; i < strings.length; i++)if (i < arglen - 1) {
            var arg = arguments[i + 1];
            var p = parse(strings[i]);
            var xstate = state;
            switch(xstate){
                case $bb4637dd63499816$var$COMMENT:
                    reg += arg;
                    arg = '';
                case $bb4637dd63499816$var$ATTR_VALUE_DQ:
                case $bb4637dd63499816$var$ATTR_VALUE_SQ:
                case $bb4637dd63499816$var$ATTR_VALUE_W:
                    xstate = $bb4637dd63499816$var$ATTR_VALUE;
                    break;
                case $bb4637dd63499816$var$ATTR:
                    xstate = $bb4637dd63499816$var$ATTR_KEY;
                    break;
            }
            p.push([
                $bb4637dd63499816$var$VAR,
                xstate,
                arg
            ]);
            parts.push.apply(parts, p);
        } else parts.push.apply(parts, parse(strings[i]));
        var tree = [
            null,
            {},
            []
        ];
        var stack = [
            [
                tree,
                -1
            ]
        ];
        for(var i = 0; i < parts.length; i++){
            var cur = stack[stack.length - 1][0];
            var p = parts[i], s = p[0];
            if (s === $bb4637dd63499816$var$OPEN && /^\//.test(p[1])) {
                var ix = stack[stack.length - 1][1];
                if (stack.length > 1) {
                    stack.pop();
                    stack[stack.length - 1][0][2][ix] = h(cur[0], cur[1], cur[2].length ? cur[2] : undefined);
                }
            } else if (s === $bb4637dd63499816$var$OPEN) {
                var c = [
                    p[1],
                    {},
                    []
                ];
                cur[2].push(c);
                stack.push([
                    c,
                    cur[2].length - 1
                ]);
            } else if (s === $bb4637dd63499816$var$ATTR_KEY || s === $bb4637dd63499816$var$VAR && p[1] === $bb4637dd63499816$var$ATTR_KEY) {
                var key = '';
                var copyKey;
                for(; i < parts.length; i++){
                    if (parts[i][0] === $bb4637dd63499816$var$ATTR_KEY) key = concat(key, parts[i][1]);
                    else if (parts[i][0] === $bb4637dd63499816$var$VAR && parts[i][1] === $bb4637dd63499816$var$ATTR_KEY) {
                        if (typeof parts[i][2] === 'object' && !key) {
                            for(copyKey in parts[i][2])if (parts[i][2].hasOwnProperty(copyKey) && !cur[1][copyKey]) cur[1][copyKey] = parts[i][2][copyKey];
                        } else key = concat(key, parts[i][2]);
                    } else break;
                }
                if (parts[i][0] === $bb4637dd63499816$var$ATTR_EQ) i++;
                var j = i;
                for(; i < parts.length; i++){
                    if (parts[i][0] === $bb4637dd63499816$var$ATTR_VALUE || parts[i][0] === $bb4637dd63499816$var$ATTR_KEY) {
                        if (!cur[1][key]) cur[1][key] = strfn(parts[i][1]);
                        else parts[i][1] === "" || (cur[1][key] = concat(cur[1][key], parts[i][1]));
                    } else if (parts[i][0] === $bb4637dd63499816$var$VAR && (parts[i][1] === $bb4637dd63499816$var$ATTR_VALUE || parts[i][1] === $bb4637dd63499816$var$ATTR_KEY)) {
                        if (!cur[1][key]) cur[1][key] = strfn(parts[i][2]);
                        else parts[i][2] === "" || (cur[1][key] = concat(cur[1][key], parts[i][2]));
                    } else {
                        if (key.length && !cur[1][key] && i === j && (parts[i][0] === $bb4637dd63499816$var$CLOSE || parts[i][0] === $bb4637dd63499816$var$ATTR_BREAK)) // https://html.spec.whatwg.org/multipage/infrastructure.html#boolean-attributes
                        // empty string is falsy, not well behaved value in browser
                        cur[1][key] = key.toLowerCase();
                        if (parts[i][0] === $bb4637dd63499816$var$CLOSE) i--;
                        break;
                    }
                }
            } else if (s === $bb4637dd63499816$var$SELF_CLOSE) {
                var ix = stack[stack.length - 1][1];
                stack.pop();
                stack[stack.length - 1][0][2][ix] = h(cur[0], cur[1], cur[2].length ? cur[2] : undefined);
            } else if (s === $bb4637dd63499816$var$VAR && p[1] === $bb4637dd63499816$var$TEXT) {
                if (p[2] === undefined || p[2] === null) p[2] = '';
                else if (!p[2]) p[2] = concat('', p[2]);
                if (Array.isArray(p[2][0])) cur[2].push.apply(cur[2], p[2]);
                else cur[2].push(p[2]);
            } else if (s === $bb4637dd63499816$var$TEXT) cur[2].push(p[1]);
            else if (s === $bb4637dd63499816$var$ATTR_EQ || s === $bb4637dd63499816$var$ATTR_BREAK || s === $bb4637dd63499816$var$CLOSE) ;
            else throw new Error('unhandled: ' + s);
        }
        if (tree[2].length > 1 && /^\s*$/.test(tree[2][0])) tree[2].shift();
        if (tree[2].length > 2 || tree[2].length === 2 && /\S/.test(tree[2][1])) throw new Error('multiple root elements must be wrapped in an enclosing tag');
        if (Array.isArray(tree[2][0]) && typeof tree[2][0][0] === 'string' && Array.isArray(tree[2][0][2])) tree[2][0] = h(tree[2][0][0], tree[2][0][1], tree[2][0][2]);
        return tree[2][0];
        function parse(str) {
            var res = [];
            if (state === $bb4637dd63499816$var$ATTR_VALUE_W) state = $bb4637dd63499816$var$ATTR;
            for(var i = 0; i < str.length; i++){
                var c = str.charAt(i);
                if (state === $bb4637dd63499816$var$COMMENT) {
                    // ignore until we get to close comment
                    if (/-$/.test(reg) && c === '-') {
                        if (opts.comments) res.push([
                            $bb4637dd63499816$var$ATTR_VALUE,
                            reg.substr(0, reg.length - 1)
                        ], [
                            $bb4637dd63499816$var$CLOSE
                        ]);
                        reg = '';
                        state = $bb4637dd63499816$var$TEXT;
                    } else {
                        reg += c;
                        continue;
                    }
                }
                if (state === $bb4637dd63499816$var$TEXT && c === '<') {
                    if (reg.length) res.push([
                        $bb4637dd63499816$var$TEXT,
                        reg
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$OPEN;
                } else if (c === '>' && str.charAt(i - 1) === '/') {
                    res.push([
                        $bb4637dd63499816$var$SELF_CLOSE
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$TEXT;
                } else if (c === '>' && str.charAt(i - 1) === '-' && str.charAt(i - 2) === '-') {
                    res.push([
                        $bb4637dd63499816$var$SELF_CLOSE
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$TEXT;
                } else if (c === '>' && !$bb4637dd63499816$var$quot(state) && state !== $bb4637dd63499816$var$COMMENT) {
                    if (state === $bb4637dd63499816$var$OPEN) res.push([
                        $bb4637dd63499816$var$OPEN,
                        reg
                    ]);
                    else if (state === $bb4637dd63499816$var$ATTR_KEY) res.push([
                        $bb4637dd63499816$var$ATTR_KEY,
                        reg
                    ]);
                    else if (state === $bb4637dd63499816$var$ATTR_VALUE && reg.length) res.push([
                        $bb4637dd63499816$var$ATTR_VALUE,
                        reg
                    ]);
                    res.push([
                        $bb4637dd63499816$var$CLOSE
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$TEXT;
                } else if (state === $bb4637dd63499816$var$OPEN && /^!--$/.test(reg)) {
                    if (opts.comments) res.push([
                        $bb4637dd63499816$var$OPEN,
                        reg
                    ], [
                        $bb4637dd63499816$var$ATTR_KEY,
                        'comment'
                    ], [
                        $bb4637dd63499816$var$ATTR_EQ
                    ]);
                    reg = c;
                    state = $bb4637dd63499816$var$COMMENT;
                } else if (state === $bb4637dd63499816$var$TEXT) reg += c;
                else if (state === $bb4637dd63499816$var$OPEN && c === '/' && reg.length) {
                    res.push([
                        $bb4637dd63499816$var$OPEN,
                        reg
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$TEXT;
                } else if (state === $bb4637dd63499816$var$OPEN && /\s/.test(c)) {
                    res.push([
                        $bb4637dd63499816$var$OPEN,
                        reg
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$ATTR;
                } else if (state === $bb4637dd63499816$var$OPEN) reg += c;
                else if (state === $bb4637dd63499816$var$ATTR && /[^\s"'=/]/.test(c)) {
                    state = $bb4637dd63499816$var$ATTR_KEY;
                    reg = c;
                } else if (state === $bb4637dd63499816$var$ATTR && /\s/.test(c)) {
                    if (reg.length) res.push([
                        $bb4637dd63499816$var$ATTR_KEY,
                        reg
                    ]);
                    res.push([
                        $bb4637dd63499816$var$ATTR_BREAK
                    ]);
                } else if (state === $bb4637dd63499816$var$ATTR_KEY && /\s/.test(c)) {
                    res.push([
                        $bb4637dd63499816$var$ATTR_KEY,
                        reg
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$ATTR_KEY_W;
                } else if (state === $bb4637dd63499816$var$ATTR_KEY && c === '=') {
                    res.push([
                        $bb4637dd63499816$var$ATTR_KEY,
                        reg
                    ], [
                        $bb4637dd63499816$var$ATTR_EQ
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$ATTR_VALUE_W;
                } else if (state === $bb4637dd63499816$var$ATTR_KEY) reg += c;
                else if ((state === $bb4637dd63499816$var$ATTR_KEY_W || state === $bb4637dd63499816$var$ATTR) && c === '=') {
                    res.push([
                        $bb4637dd63499816$var$ATTR_EQ
                    ]);
                    state = $bb4637dd63499816$var$ATTR_VALUE_W;
                } else if ((state === $bb4637dd63499816$var$ATTR_KEY_W || state === $bb4637dd63499816$var$ATTR) && !/\s/.test(c)) {
                    res.push([
                        $bb4637dd63499816$var$ATTR_BREAK
                    ]);
                    if (/[\w-]/.test(c)) {
                        reg += c;
                        state = $bb4637dd63499816$var$ATTR_KEY;
                    } else state = $bb4637dd63499816$var$ATTR;
                } else if (state === $bb4637dd63499816$var$ATTR_VALUE_W && c === '"') state = $bb4637dd63499816$var$ATTR_VALUE_DQ;
                else if (state === $bb4637dd63499816$var$ATTR_VALUE_W && c === "'") state = $bb4637dd63499816$var$ATTR_VALUE_SQ;
                else if (state === $bb4637dd63499816$var$ATTR_VALUE_DQ && c === '"') {
                    res.push([
                        $bb4637dd63499816$var$ATTR_VALUE,
                        reg
                    ], [
                        $bb4637dd63499816$var$ATTR_BREAK
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$ATTR;
                } else if (state === $bb4637dd63499816$var$ATTR_VALUE_SQ && c === "'") {
                    res.push([
                        $bb4637dd63499816$var$ATTR_VALUE,
                        reg
                    ], [
                        $bb4637dd63499816$var$ATTR_BREAK
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$ATTR;
                } else if (state === $bb4637dd63499816$var$ATTR_VALUE_W && !/\s/.test(c)) {
                    state = $bb4637dd63499816$var$ATTR_VALUE;
                    i--;
                } else if (state === $bb4637dd63499816$var$ATTR_VALUE && /\s/.test(c)) {
                    res.push([
                        $bb4637dd63499816$var$ATTR_VALUE,
                        reg
                    ], [
                        $bb4637dd63499816$var$ATTR_BREAK
                    ]);
                    reg = '';
                    state = $bb4637dd63499816$var$ATTR;
                } else if (state === $bb4637dd63499816$var$ATTR_VALUE || state === $bb4637dd63499816$var$ATTR_VALUE_SQ || state === $bb4637dd63499816$var$ATTR_VALUE_DQ) reg += c;
            }
            if (reg.length) switch(state){
                case $bb4637dd63499816$var$TEXT:
                    res.push([
                        $bb4637dd63499816$var$TEXT,
                        reg
                    ]);
                    reg = '';
                    break;
                case $bb4637dd63499816$var$ATTR_VALUE:
                case $bb4637dd63499816$var$ATTR_VALUE_DQ:
                case $bb4637dd63499816$var$ATTR_VALUE_SQ:
                    res.push([
                        $bb4637dd63499816$var$ATTR_VALUE,
                        reg
                    ]);
                    reg = '';
                    break;
            }
            if (state === $bb4637dd63499816$var$ATTR_KEY) {
                res.push([
                    $bb4637dd63499816$var$ATTR_KEY,
                    reg
                ]);
                reg = '';
            }
            return res;
        }
    };
};
const $bb4637dd63499816$var$quot = (state)=>state === $bb4637dd63499816$var$ATTR_VALUE_SQ || state === $bb4637dd63499816$var$ATTR_VALUE_DQ;


/**
 * This function takes in a namespace and registry of custom components,
 * and builds a `dom` template tag function that can take in a template XML string.
 *
 * This function shouldn't need to be called directly, instead, you can use `registerHtml` or `registerSvg`
 *
 * @param registry mapping of tag names to component functions
 * @param namespace namespace to create nodes in (by default XHTML namespace)
 */ const $2e682f50ad48c6fc$var$registerDom = (namespace, registry = {})=>{
    // modify the registry so that each component function updates the hook working key
    const hookedRegistry = Object.keys(registry).reduce((newRegistry, tagName)=>{
        const tagFunction = registry[tagName];
        const hookedTagFunction = (props, children)=>{
            // push a new branch onto the working key so any values that need to be unique among components
            // but consistent across renders can be read
            const stringifiedProps = JSON.stringify(props);
            const newBranch = `${tagName}[${stringifiedProps}]`;
            $2e682f50ad48c6fc$var$pushWorkingKeyBranch($2e682f50ad48c6fc$var$TRAM_HOOK_KEY, newBranch);
            // increment branch so that we have a unique value (in case we are rendering a list of components)
            $2e682f50ad48c6fc$var$incrementWorkingKeyBranch($2e682f50ad48c6fc$var$TRAM_HOOK_KEY);
            const uniqueBranch = $2e682f50ad48c6fc$var$copyWorkingKey($2e682f50ad48c6fc$var$TRAM_HOOK_KEY);
            // create a tag function that has the args passed in
            const populatedTagFunction = ()=>{
                // reset working key so we have the correct place when starting a new component
                $2e682f50ad48c6fc$var$restoreWorkingKey($2e682f50ad48c6fc$var$TRAM_HOOK_KEY, uniqueBranch);
                const processedChildren = children?.map((child)=>{
                    if (child instanceof Element) return child;
                    return `${child}`;
                });
                return tagFunction(props, processedChildren);
            };
            // observe store usage and process any new effects that were called when building the component
            const processHooksAndBuildTagResult = ()=>$2e682f50ad48c6fc$var$processHooks(populatedTagFunction);
            const tagResult = $2e682f50ad48c6fc$var$observeTag(processHooksAndBuildTagResult);
            // pop the branch off (since we are done rendering this component)
            $2e682f50ad48c6fc$var$popWorkingKeyBranch($2e682f50ad48c6fc$var$TRAM_HOOK_KEY);
            // decorate the properties expected on TramOneElements (see node-names.ts)
            tagResult[$2e682f50ad48c6fc$var$TRAM_TAG] = true;
            // we won't decorate TRAM_TAG_REACTION, that needs to be done later when we observe the tag
            tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS] = tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS] || [];
            // cleanup effects will be populated when new effects are processed
            tagResult[$2e682f50ad48c6fc$var$TRAM_TAG_CLEANUP_EFFECTS] = [];
            return tagResult;
        };
        return {
            ...newRegistry,
            [tagName]: hookedTagFunction
        };
    }, {});
    return $19b97d144575daf1$exports($bb4637dd63499816$exports, $5912e0d8006d4e74$exports(namespace), hookedRegistry);
};
/**
 * @name useEffect
 * @link https://tram-one.io/#use-effect
 * @description
 * Hook that triggers component start, update, and cleanup effects.
 * If the return of effect is another function, then that function is called on when the component is removed.
 * If the effect is dependent on a observable, it will automatically trigger again if that value updates.
 *
 * @param effect function to run on component mount
 */ var $2e682f50ad48c6fc$export$6d9c69b0de29b591 = (effect)=>{
    // get the store of effects
    const effectQueue = $2e682f50ad48c6fc$var$getEffectStore($2e682f50ad48c6fc$var$TRAM_EFFECT_QUEUE);
    // get the key value from working-key
    const key = $2e682f50ad48c6fc$var$getWorkingKeyValue($2e682f50ad48c6fc$var$TRAM_HOOK_KEY);
    // increment the working key branch value
    // this makes successive useEffects calls unique (until we reset the key)
    $2e682f50ad48c6fc$var$incrementWorkingKeyBranch($2e682f50ad48c6fc$var$TRAM_HOOK_KEY);
    // append () so that it's easier to debug effects from components
    const callLikeKey = `${key}()`;
    // add the effect to the effect queue, so it can be processed later
    effectQueue[callLikeKey] = effect;
};
const $2e682f50ad48c6fc$var$xml = $2e682f50ad48c6fc$var$registerDom(null);
const $2e682f50ad48c6fc$var$fragment = (props, children)=>{
    $2e682f50ad48c6fc$export$6d9c69b0de29b591((ref)=>{
        (children || []).forEach((child)=>{
            if (typeof child === 'string') ref.insertAdjacentText('beforebegin', child);
            else ref.insertAdjacentElement('beforebegin', child);
        });
        ref.remove();
    });
    return $2e682f50ad48c6fc$var$xml`<tram-fragment>${children}</tram-fragment>`;
};
/**
 * @name registerHtml
 * @link https://tram-one.io/#register-html
 * @description
 * Function to generate a tagged template function for XHTML / HTML.
 * Takes in a registry that allows you to import other tag functions and use them in your template string.
 *
 * @param registry map of tag names to functions, use this to use custom elements built in tram-one
 * @return tagged template function that builds HTML components
 */ const $2e682f50ad48c6fc$export$cd8b0dba543a4992 = (registry)=>{
    return $2e682f50ad48c6fc$var$registerDom(null, {
        '': $2e682f50ad48c6fc$var$fragment,
        ...registry
    });
};
/**
 * @name registerSvg
 * @link https://tram-one.io/#register-svg
 * @description
 * Function to generate a tagged template function for SVG.
 *
 * @param registry map of tag names to functions, use this to use custom elements built in tram-one
 * @return tagged template function that builds SVG components
 */ const $2e682f50ad48c6fc$export$cf400134d4350689 = (registry)=>{
    return $2e682f50ad48c6fc$var$registerDom('http://www.w3.org/2000/svg', {
        '': $2e682f50ad48c6fc$var$fragment,
        ...registry
    });
};

var $2e682f50ad48c6fc$require$observable = $1682bfda3685e13f$export$5ab46cbf6120b33a;
/*
 * Observable Stores in Tram-One are used for objects whose properties need to be observed.
 * This stores the values in the useStore and useGlobalStore hooks, internally tracking
 * them as proxies, and making observed functions respond to their changes.
 */ const { setup: $2e682f50ad48c6fc$var$setupObservableStore, get: $2e682f50ad48c6fc$var$getObservableStore } = $2e682f50ad48c6fc$var$buildNamespace(()=>$2e682f50ad48c6fc$require$observable({}));
/**
 * Shared source code for both observable hooks, useStore, and useGlobalStore.
 * This hook exposes a globally stored value (in either case), that can cause the component
 * to update when a subfield of that value is updated.
 *
 * It has a similar interface to React's useState
 */ var $2e682f50ad48c6fc$var$observableHook = (key, value)=>{
    // get the store of effects
    const observableStore = $2e682f50ad48c6fc$var$getObservableStore($2e682f50ad48c6fc$var$TRAM_OBSERVABLE_STORE);
    // increment the working key branch value
    // this makes successive hooks unique (until we reset the key)
    $2e682f50ad48c6fc$var$incrementWorkingKeyBranch($2e682f50ad48c6fc$var$TRAM_HOOK_KEY);
    // if a key was passed in, use that, otherwise, generate a key
    const resolvedKey = key || $2e682f50ad48c6fc$var$getWorkingKeyValue($2e682f50ad48c6fc$var$TRAM_HOOK_KEY);
    // saves value into the store if it doesn't exist in the observableStore yet
    // and if the value we are writing is defined
    if (!Object.prototype.hasOwnProperty.call(observableStore, resolvedKey) && value !== undefined) // save the value as a shallow copy of the parameter passed in
    observableStore[resolvedKey] = Array.isArray(value) ? [
        ...value
    ] : {
        ...value
    };
    // get value for key
    const keyValue = observableStore[resolvedKey];
    // if we weren't passed in a key, this is a local obserable (not global),
    const isLocalStore = !key;
    if (isLocalStore) // if this is local, we should associate it with the element by putting it in the keyQueue
    $2e682f50ad48c6fc$var$getKeyQueue($2e682f50ad48c6fc$var$TRAM_KEY_QUEUE).push(resolvedKey);
    // if this is a development environment, save the global store key to the element
    isLocalStore;
    // return value
    return keyValue;
};
/**
 * @name useStore
 * @link https://tram-one.io/#use-store
 * @description
 * Hook that stores local component state.
 *
 * If the subfield of an object, or element of an array is updated
 * it will cause only the components that are dependent on that value to update.
 *
 * @param defaultValue the default value to start the store at
 *
 * @returns the store to interact with.
 */ var $2e682f50ad48c6fc$export$6ccbb43953eebf8 = (defaultValue)=>$2e682f50ad48c6fc$var$observableHook(undefined, defaultValue);
var $a4b7e27c66f03531$exports = {};
$a4b7e27c66f03531$exports = (callback)=>{
    window.addEventListener('hashchange', callback, false);
    window.addEventListener('popstate', callback, false);
    const pushState = window.history.pushState;
    window.history.pushState = (state, ...args)=>{
        const returnValue = pushState.apply(history, [
            state
        ].concat(args));
        callback({
            state: state
        });
        return returnValue;
    };
};


var $e8c4b94ca5d8d116$exports = {};
var $422f3200d4cd2dd4$exports = {};
var $b1b336c62b6dd252$exports = {};
var $528d53ce2c5024fa$exports = {};
// This library started as an experiment to see how small I could make
// a functional router. It has since been optimized (and thus grown).
// The redundancy and inelegance here is for the sake of either size
// or speed.
//
// That's why router params are marked with a single char: `~` and named params are denoted `:`
(function(root, factory) {
    var define = root && root.define;
    if (define && define.amd) define('rlite', [], factory);
    else if ($528d53ce2c5024fa$exports) $528d53ce2c5024fa$exports = factory();
    else root.Rlite = factory();
})($528d53ce2c5024fa$exports, function() {
    return function(notFound, routeDefinitions) {
        var routes = {};
        var decode = decodeURIComponent;
        init();
        return run;
        function init() {
            for(var key in routeDefinitions)add(key, routeDefinitions[key]);
        }
        function noop(s) {
            return s;
        }
        function sanitize(url) {
            ~url.indexOf('/?') && (url = url.replace('/?', '?'));
            url[0] == '/' && (url = url.slice(1));
            url[url.length - 1] == '/' && (url = url.slice(0, -1));
            return url;
        }
        // Recursively searches the route tree for a matching route
        // pieces: an array of url parts, ['users', '1', 'edit']
        // esc: the function used to url escape values
        // i: the index of the piece being processed
        // rules: the route tree
        // params: the computed route parameters (this is mutated), and is a stack since we don't have fast immutable datatypes
        //
        // This attempts to match the most specific route, but may end int a dead-end. We then attempt a less specific
        // route, following named route parameters. In searching this secondary branch, we need to make sure to clear
        // any route params that were generated during the search of the dead-end branch.
        function recurseUrl(pieces, esc, i, rules, params) {
            if (!rules) return;
            if (i >= pieces.length) {
                var cb = rules['@'];
                return cb && {
                    cb: cb,
                    params: params.reduce(function(h, kv) {
                        h[kv[0]] = kv[1];
                        return h;
                    }, {})
                };
            }
            var piece = esc(pieces[i]);
            var paramLen = params.length;
            return recurseUrl(pieces, esc, i + 1, rules[piece.toLowerCase()], params) || recurseNamedUrl(pieces, esc, i + 1, rules, ':', piece, params, paramLen) || recurseNamedUrl(pieces, esc, pieces.length, rules, '*', pieces.slice(i).join('/'), params, paramLen);
        }
        // Recurses for a named route, where the name is looked up via key and associated with val
        function recurseNamedUrl(pieces, esc, i, rules, key, val, params, paramLen) {
            params.length = paramLen; // Reset any params generated in the unsuccessful search branch
            var subRules = rules[key];
            subRules && params.push([
                subRules['~'],
                val
            ]);
            return recurseUrl(pieces, esc, i, subRules, params);
        }
        function processQuery(url, ctx, esc) {
            if (url && ctx.cb) {
                var hash = url.indexOf('#'), query = (hash < 0 ? url : url.slice(0, hash)).split('&');
                for(var i = 0; i < query.length; ++i){
                    var nameValue = query[i].split('=');
                    ctx.params[nameValue[0]] = esc(nameValue[1]);
                }
            }
            return ctx;
        }
        function lookup(url) {
            var querySplit = sanitize(url).split('?');
            var esc = ~url.indexOf('%') ? decode : noop;
            return processQuery(querySplit[1], recurseUrl(querySplit[0].split('/'), esc, 0, routes, []) || {}, esc);
        }
        function add(route, handler) {
            var pieces = route.split('/');
            var rules = routes;
            for(var i = +(route[0] === '/'); i < pieces.length; ++i){
                var piece = pieces[i];
                var name = piece[0] == ':' ? ':' : piece[0] == '*' ? '*' : piece.toLowerCase();
                rules = rules[name] || (rules[name] = {});
                (name == ':' || name == '*') && (rules['~'] = piece.slice(1));
            }
            rules['@'] = handler;
        }
        function run(url, arg) {
            var result = lookup(url);
            return (result.cb || notFound)(result.params, arg, url);
        }
    };
});


const $b1b336c62b6dd252$var$onNonMatchingPath = ()=>({
        matches: false
    });
const $b1b336c62b6dd252$var$returnParams = (params)=>({
        matches: true,
        ...params
    });
$b1b336c62b6dd252$exports = (getPath)=>(pattern = '*')=>$528d53ce2c5024fa$exports($b1b336c62b6dd252$var$onNonMatchingPath, {
            [pattern]: $b1b336c62b6dd252$var$returnParams
        })(getPath());


/**
 * @see https://tram-one.io/api/#Tram-One#useUrlParams
 * @name useUrlParams
 *
 * @param {function} [getPath] - function to return the current path, defaults to reading window.location.href
 * @returns the useUrlParams hook
 */ $422f3200d4cd2dd4$exports = $b1b336c62b6dd252$exports;


var $cd61df0301df60b5$exports = {};

const $cd61df0301df60b5$var$defaultGetPath = ()=>{
    // strip origin from url
    const fullUrl = window.location.href;
    const urlPath = fullUrl.replace(window.location.origin, '');
    const [urlWithoutHash, hash] = urlPath.split('#');
    // check if the url has a parameter (so we can determine how to re-add the hash)
    const urlHasParam = urlWithoutHash.includes('?');
    const hashParameter = hash !== undefined ? urlHasParam ? `&hash=${hash}` : `?hash=${hash}` : '';
    // return the complete url with hash-fragment as query param
    // e.g. tram-one.io#features => tram-one.io?hash=features
    const urlWithHashAsParam = `${urlWithoutHash}${hashParameter}`;
    return urlWithHashAsParam;
};
/**
 * @see https://tram-one.io/#use-url-params
 *
 * @description
 * Hook that returns path variables based on the route.
 * Can return path parameters, query params, and more.
 * It's internal functionality is powered by the package
 * {@link https://www.npmjs.com/package/rlite-router | rlite}
 *
 * Rather than using XML templates to define routes, this method enables
 * routing in javascript.https://github.com/Tram-One/useUrlParams/pull/9
 *
 * @param {String} [pattern] path for resolving path parameters (not required for query params)
 *
 * @returns {Object} object with a `matches` key, and (if it matched) path and query parameters
 */ $cd61df0301df60b5$exports = $b1b336c62b6dd252$exports($cd61df0301df60b5$var$defaultGetPath);


$e8c4b94ca5d8d116$exports = $cd61df0301df60b5$exports;
$cd61df0301df60b5$exports.setupUrlParams = $422f3200d4cd2dd4$exports;
$cd61df0301df60b5$exports.useUrlParams = $cd61df0301df60b5$exports;


/**
 * @name useUrlParams
 * @link https://tram-one.io/#use-url-params
 * @description
 * Hook that returns path variables based on the route.
 * Can return path parameters, query params, and more.
 * It's internal functionality is powered by the package
 * {@link https://www.npmjs.com/package/rlite-router rlite}
 *
 * @param pattern path to match on (can include path variables)
 *
 * @returns object with a `matches` key, and (if it matched) path and query parameters
 */ var $2e682f50ad48c6fc$export$e6e5b8581d1497b0 = (pattern)=>{
    // save and update results in an observable, so that we can update
    // components and effects in a reactive way
    const initialParams = $e8c4b94ca5d8d116$exports(pattern);
    const observedUrlParams = $2e682f50ad48c6fc$export$6ccbb43953eebf8(initialParams);
    // urlListener can re-read the route and save the new results to the observable
    $a4b7e27c66f03531$exports(()=>{
        const updatedParams = $e8c4b94ca5d8d116$exports(pattern);
        // get all keys so we can override new and old ones (without having to override the whole object)
        const allParamKeys = [
            ...Object.keys(initialParams),
            ...Object.keys(updatedParams)
        ];
        allParamKeys.forEach((paramKey)=>{
            observedUrlParams[paramKey] = updatedParams[paramKey];
        });
    });
    return observedUrlParams;
};
/** Implementation of the two function definitions */ function $2e682f50ad48c6fc$export$ea7f481060e2c12e(key, defaultValue) {
    return $2e682f50ad48c6fc$var$observableHook(key, defaultValue);
}
/**
 * Updates a container with an initial component for the first render.
 * @param component the tram-one component to render
 * @param container an element to render the component on
 */ var $2e682f50ad48c6fc$var$mount = (component, container)=>{
    const html = $2e682f50ad48c6fc$export$cd8b0dba543a4992({
        app: component
    });
    // this sadly needs to be wrapped in some element so we can process effects
    // otherwise the root node will not have effects applied on it
    const renderedApp = html`<tram-one><app /></tram-one>`;
    container.replaceChild(renderedApp, container.firstElementChild);
};
/**
 * Helper function for getting an element when given a string or element
 * @param target either a CSS selector, or Element to attach the component to.
 * @returns the container that we can mount on
 */ const $2e682f50ad48c6fc$var$getContainerElement = (target)=>{
    // if the selector is a string, try to find the element,
    // otherwise it's probably DOM that we should write directly to
    if (typeof target === 'string') {
        const selectedElement = document.querySelector(target);
        if (selectedElement === null) throw new Error(`
				Tram-One: could not find target, is the element on the page yet?
				https://github.com/Tram-One/tram-one/issues/179
			`);
        return selectedElement;
    } else return target;
};
/**
 * Function to determine (or create) the element that we will mount our tram-one app onto
 * @param target either a CSS selector, or Element to attach the component to.
 * This elememnt should be initially empty.
 *
 * @returns the container, now with a div that tram-one can manage
 */ var $2e682f50ad48c6fc$var$buildContainer = (target)=>{
    const container = $2e682f50ad48c6fc$var$getContainerElement(target);
    // build a div to render the app on
    // - if it doesn't exist as a child of the selector, create one first
    if (!container.firstElementChild) {
        const containerChild = document.createElement('div');
        container.appendChild(containerChild);
    }
    return container;
};
/*
 * The KeyStore in Tram-One is a basic key-value object
 * that needs to be persisted in the globalSpace.
 *
 * Currently this is used with useStore and useGlobalStore to keep
 * track of what stores need to be cleaned up when removing elements
 */ const $2e682f50ad48c6fc$var$newDefaultKeyStore = ()=>{
    return {};
};
const { setup: $2e682f50ad48c6fc$var$setupKeyStore, get: $2e682f50ad48c6fc$var$getKeyStore, set: $2e682f50ad48c6fc$var$setKeyStore } = $2e682f50ad48c6fc$var$buildNamespace($2e682f50ad48c6fc$var$newDefaultKeyStore);
/**
 * increment (or set initial value) for the keyStore
 */ const $2e682f50ad48c6fc$var$incrementKeyStoreValue = (keyStoreName, key)=>{
    const keyStore = $2e682f50ad48c6fc$var$getKeyStore(keyStoreName);
    keyStore[key] = keyStore[key] + 1 || 1;
};
/**
 * decrement a value in the keyStore
 */ const $2e682f50ad48c6fc$var$decrementKeyStoreValue = (keyStoreName, key)=>{
    const keyStore = $2e682f50ad48c6fc$var$getKeyStore(keyStoreName);
    keyStore[key]--;
};

var $2e682f50ad48c6fc$require$observe = $1682bfda3685e13f$export$d1203567a167490e;
var $2e682f50ad48c6fc$require$unobserve = $1682bfda3685e13f$export$23a2283368c55ea2;
/**
 * process side-effects for new tram-one nodes
 * (this includes calling effects, and keeping track of stores)
 */ const $2e682f50ad48c6fc$var$processTramTags = (node)=>{
    // if this element doesn't have a TRAM_TAG, it's not a Tram-One Element
    if (!($2e682f50ad48c6fc$var$TRAM_TAG in node)) return;
    const hasStoreKeys = node[$2e682f50ad48c6fc$var$TRAM_TAG_STORE_KEYS];
    if (hasStoreKeys) // for every store associated with this element, increment the count
    // - this ensures that it doesn't get blown away when we clean up old stores
    node[$2e682f50ad48c6fc$var$TRAM_TAG_STORE_KEYS].forEach((key)=>{
        $2e682f50ad48c6fc$var$incrementKeyStoreValue($2e682f50ad48c6fc$var$TRAM_KEY_STORE, key);
    });
    const hasEffects = node[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS];
    if (hasEffects) {
        // create an array for the cleanup effects
        node[$2e682f50ad48c6fc$var$TRAM_TAG_CLEANUP_EFFECTS] = [];
        // run all the effects, saving any cleanup functions to the node
        node[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS].forEach((effect)=>{
            let cleanup;
            // this is called when an effect is re-triggered
            const effectReaction = $2e682f50ad48c6fc$require$observe(()=>{
                // verify that cleanup is a function before calling it (in case it was a promise)
                if (typeof cleanup === 'function') cleanup();
                cleanup = effect(node);
            });
            // this is called when a component with an effect is removed
            const totalCleanup = ()=>{
                // verify that cleanup is a function before calling it (in case it was a promise)
                if (typeof cleanup === 'function') cleanup();
                $2e682f50ad48c6fc$require$unobserve(effectReaction);
            };
            node[$2e682f50ad48c6fc$var$TRAM_TAG_CLEANUP_EFFECTS].push(totalCleanup);
        });
        // set new tag effects to an empty array
        node[$2e682f50ad48c6fc$var$TRAM_TAG_NEW_EFFECTS] = [];
    }
};
/**
 * call all cleanup effects on the node
 */ const $2e682f50ad48c6fc$var$cleanupEffects = (cleanupEffects)=>{
    cleanupEffects.forEach((cleanup)=>cleanup());
};
/**
 * remove the association of the store with this specific element
 */ const $2e682f50ad48c6fc$var$removeStoreKeyAssociation = (storeKeys)=>{
    storeKeys.forEach((storeKey)=>{
        $2e682f50ad48c6fc$var$decrementKeyStoreValue($2e682f50ad48c6fc$var$TRAM_KEY_STORE, storeKey);
    });
};
/**
 * remove any stores that no longer have any elements associated with them
 * see removeStoreKeyAssociation above
 */ const $2e682f50ad48c6fc$var$cleanUpObservableStores = ()=>{
    const observableStore = $2e682f50ad48c6fc$var$getObservableStore($2e682f50ad48c6fc$var$TRAM_OBSERVABLE_STORE);
    const keyStore = $2e682f50ad48c6fc$var$getKeyStore($2e682f50ad48c6fc$var$TRAM_KEY_STORE);
    Object.entries(keyStore).forEach(([key, observers])=>{
        if (observers === 0) {
            delete observableStore[key];
            delete keyStore[key];
        }
    });
};
/**
 * unobserve the reaction tied to the node, and run all cleanup effects for the node
 */ const $2e682f50ad48c6fc$var$clearNode = (node)=>{
    // if this element doesn't have a TRAM_TAG, it's not a Tram-One Element
    if (!($2e682f50ad48c6fc$var$TRAM_TAG in node)) return;
    $2e682f50ad48c6fc$require$unobserve(node[$2e682f50ad48c6fc$var$TRAM_TAG_REACTION]);
    $2e682f50ad48c6fc$var$cleanupEffects(node[$2e682f50ad48c6fc$var$TRAM_TAG_CLEANUP_EFFECTS]);
    $2e682f50ad48c6fc$var$removeStoreKeyAssociation(node[$2e682f50ad48c6fc$var$TRAM_TAG_STORE_KEYS]);
};
const $2e682f50ad48c6fc$var$isTramOneComponent = (node)=>{
    // a node is a component if it has `TRAM_TAG` key on it
    const nodeIsATramOneComponent = $2e682f50ad48c6fc$var$TRAM_TAG in node;
    // if it is a tram-one component, we want to process it, otherwise skip it
    return nodeIsATramOneComponent ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
};
/**
 * function to get the children (as a list) of the node passed in
 */ const $2e682f50ad48c6fc$var$childrenComponents = (node)=>{
    const componentWalker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT, $2e682f50ad48c6fc$var$isTramOneComponent);
    const children = [];
    while(componentWalker.nextNode())children.push(componentWalker.currentNode);
    return children;
};
const $2e682f50ad48c6fc$var$mutationObserverNamespaceConstructor = ()=>new MutationObserver((mutationList)=>{
        // cleanup orphaned nodes that are no longer on the DOM
        const removedNodesInMutation = (mutation)=>[
                ...mutation.removedNodes
            ];
        const removedNodes = mutationList.flatMap(removedNodesInMutation);
        const removedChildNodes = removedNodes.flatMap($2e682f50ad48c6fc$var$childrenComponents);
        removedChildNodes.forEach($2e682f50ad48c6fc$var$clearNode);
        // call new effects on any new nodes
        const addedNodesInMutation = (mutation)=>[
                ...mutation.addedNodes
            ];
        const newNodes = mutationList.flatMap(addedNodesInMutation);
        const newChildNodes = newNodes.flatMap($2e682f50ad48c6fc$var$childrenComponents);
        newChildNodes.forEach($2e682f50ad48c6fc$var$processTramTags);
        // clean up all local observable stores that have no observers
        $2e682f50ad48c6fc$var$cleanUpObservableStores();
    });
const { setup: $2e682f50ad48c6fc$var$setupMutationObserver, get: $2e682f50ad48c6fc$var$getMutationObserver } = $2e682f50ad48c6fc$var$buildNamespace($2e682f50ad48c6fc$var$mutationObserverNamespaceConstructor);
// tell the mutation observer to watch the given node for changes
const $2e682f50ad48c6fc$var$startWatcher = (observerName, node)=>{
    const observerStore = $2e682f50ad48c6fc$var$getMutationObserver(observerName);
    observerStore.observe(node, {
        childList: true,
        subtree: true
    });
};
/**
 * @name start
 * @link https://tram-one.io/#start
 * @description
 * Function to attach a component to an existing element on the page.
 * This function also starts all the listeners and allows the basic hooks to function.
 *
 * This should only be called for the initial render / building of the app.
 *
 * @param component top-level component to attach to the page.
 * @param target either a CSS selector, or Node to attach the component to
 */ var $2e682f50ad48c6fc$export$b3571188c770cc5a = (component, target)=>{
    /* setup all the internal engines required for tram-one to work */ // get the container to mount the app on
    const container = $2e682f50ad48c6fc$var$buildContainer(target);
    // setup the window object to hold stores and queues
    // in the future, we may allow this to be customized
    // for multiple, sandboxed, instances of Tram-One
    $2e682f50ad48c6fc$var$setupTramOneSpace();
    // setup store for effects
    $2e682f50ad48c6fc$var$setupEffectStore($2e682f50ad48c6fc$var$TRAM_EFFECT_STORE);
    // setup queue for new effects when resolving mounts
    $2e682f50ad48c6fc$var$setupEffectStore($2e682f50ad48c6fc$var$TRAM_EFFECT_QUEUE);
    // setup working key for hooks
    $2e682f50ad48c6fc$var$setupWorkingKey($2e682f50ad48c6fc$var$TRAM_HOOK_KEY);
    // setup observable store for the useStore and useGlobalStore hooks
    $2e682f50ad48c6fc$var$setupObservableStore($2e682f50ad48c6fc$var$TRAM_OBSERVABLE_STORE);
    // setup key store for keeping track of stores to clean up
    $2e682f50ad48c6fc$var$setupKeyStore($2e682f50ad48c6fc$var$TRAM_KEY_STORE);
    // setup key queue for new observable stores when resolving mounts
    $2e682f50ad48c6fc$var$setupKeyQueue($2e682f50ad48c6fc$var$TRAM_KEY_QUEUE);
    // setup key queue for global observable stores when resolving mounts
    $2e682f50ad48c6fc$var$setupKeyQueue($2e682f50ad48c6fc$var$TRAM_GLOBAL_KEY_QUEUE);
    // setup a mutation observer for cleaning up removed elements and triggering effects
    $2e682f50ad48c6fc$var$setupMutationObserver($2e682f50ad48c6fc$var$TRAM_MUTATION_OBSERVER);
    // watch for changes on the target so that we can process node changes
    $2e682f50ad48c6fc$var$startWatcher($2e682f50ad48c6fc$var$TRAM_MUTATION_OBSERVER, container);
    // trigger an initial mount
    $2e682f50ad48c6fc$var$mount(component, container);
};





const $e111026c1c9a385d$export$6c39a76dc399236a = async ()=>{
    try {
        const sessionData = await fetch('/api/profile', {
            credentials: 'same-origin'
        });
        const sessionDataObject = await sessionData.json();
        if (sessionDataObject.error) throw {
            message: sessionDataObject.error,
            status: sessionData.status
        };
        return sessionDataObject;
    } catch (error) {
        return {
            error: true,
            message: error.message,
            status: error.status
        };
    }
};
const $e111026c1c9a385d$export$83628895f1965282 = async ()=>{
    try {
        const keywordResponse = await fetch('/api/keywords', {
            credentials: 'same-origin'
        });
        const keywords = await keywordResponse.json();
        if (!Array.isArray(keywords) && keywords.error === true) throw {
            message: keywords.error,
            status: keywordResponse.status
        };
        const toSingleKeywordStore = (workingStore, newKeyword)=>{
            const hasWhitelistedSubreddits = newKeyword?.filters?.whitelist?.subreddits;
            const hasWhitelistedUsers = newKeyword?.filters?.whitelist?.users;
            const subreddits = newKeyword?.filters?.whitelist?.subreddits || newKeyword?.filters?.blacklist?.subreddits || [];
            const users = newKeyword?.filters?.whitelist?.users || newKeyword?.filters?.blacklist?.users || [];
            workingStore[newKeyword.key] = {
                id: newKeyword.id,
                key: newKeyword.key,
                // if there is a legacy source (empty string or null), treat that as comments only.
                source: newKeyword.source === '' || newKeyword.source === null ? 'comments' : newKeyword.source,
                subreddits: {
                    type: hasWhitelistedSubreddits ? 'whitelist' : 'blacklist',
                    values: new Set(subreddits)
                },
                users: {
                    type: hasWhitelistedUsers ? 'whitelist' : 'blacklist',
                    values: new Set(users)
                },
                dirty: false
            };
            return workingStore;
        };
        const serverKeywordClientStore = keywords.reduce(toSingleKeywordStore, {});
        return {
            error: false,
            data: serverKeywordClientStore
        };
    } catch (error) {
        return {
            error: true,
            message: error.message,
            status: error.status
        };
    }
};
const $e111026c1c9a385d$var$keywordToServerModel = (keywordObject)=>{
    return {
        id: keywordObject.id,
        key: keywordObject.key,
        source: keywordObject.source,
        filters: {
            blacklist: {
                subreddits: keywordObject.subreddits.type === 'blacklist' ? Array.from(keywordObject.subreddits.values) : undefined,
                users: keywordObject.users.type === 'blacklist' ? Array.from(keywordObject.users.values) : undefined
            },
            whitelist: {
                subreddits: keywordObject.subreddits.type === 'whitelist' ? Array.from(keywordObject.subreddits.values) : undefined,
                users: keywordObject.users.type === 'whitelist' ? Array.from(keywordObject.users.values) : undefined
            }
        }
    };
};
const $e111026c1c9a385d$export$1268a3b77d58fa65 = async (keywordObject)=>{
    try {
        const createKeywordResponse = await fetch('/api/keywords', {
            method: 'PUT',
            credentials: 'same-origin',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify($e111026c1c9a385d$var$keywordToServerModel(keywordObject))
        });
        const keywordResponseObject = await createKeywordResponse.json();
        if (keywordResponseObject.error) throw {
            message: keywordResponseObject.error,
            status: createKeywordResponse.status
        };
        return keywordResponseObject;
    } catch (error) {
        return {
            error: true,
            message: error.message,
            status: error.status
        };
    }
};
const $e111026c1c9a385d$export$48514181e03470c = async (keywordObject)=>{
    try {
        const createKeywordResponse = await fetch('/api/keywords', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify($e111026c1c9a385d$var$keywordToServerModel(keywordObject))
        });
        const keywordResponseObject = await createKeywordResponse.json();
        if (keywordResponseObject.error) throw {
            message: keywordResponseObject.error,
            status: createKeywordResponse.status
        };
        return keywordResponseObject;
    } catch (error) {
        return {
            error: true,
            message: error.message,
            status: error.status
        };
    }
};
const $e111026c1c9a385d$export$f5b865e5421e10a3 = async (keywordObject)=>{
    try {
        const deleteResponse = await fetch('/api/keywords', {
            method: 'DELETE',
            credentials: 'same-origin',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify($e111026c1c9a385d$var$keywordToServerModel(keywordObject))
        });
        // right now delete doesn't return anything, but if it ever does, we'll want this
        // const deleteResponseObject = await deleteResponse.json();
        // if (deleteResponseObject.error) {
        // 	throw { message: deleteResponseObject.error };
        // }
        return {
            error: false
        };
    } catch (error) {
        return {
            error: true,
            message: error.message
        };
    }
};



const $2fb3b93ec1994bc7$var$defaultNotificationStore = ()=>({
        message: '',
        visible: false,
        type: 'success'
    });
const $2fb3b93ec1994bc7$export$9949bd9c713ba425 = ()=>{
    const notificationStore = (0, $2e682f50ad48c6fc$export$ea7f481060e2c12e)('NOTIFICATION', $2fb3b93ec1994bc7$var$defaultNotificationStore());
    const getNotificationMessage = ()=>{
        return notificationStore;
    };
    const setMessage = (message, type)=>{
        notificationStore.message = message;
        notificationStore.type = type;
        notificationStore.visible = true;
    };
    const dismissNotification = ()=>{
        notificationStore.visible = false;
    };
    return {
        getNotificationMessage: getNotificationMessage,
        setMessage: setMessage,
        dismissNotification: dismissNotification
    };
};


const $17ea58b1aa86ae1d$var$defaultUserStore = ()=>({
        loggedIn: false,
        loading: false,
        id: null,
        username: '',
        accountType: '',
        keyLimit: 0
    });
const $17ea58b1aa86ae1d$export$23bbbc4533528f03 = ()=>{
    const userStore = (0, $2e682f50ad48c6fc$export$ea7f481060e2c12e)('USER_STORE', $17ea58b1aa86ae1d$var$defaultUserStore());
    const { setMessage: setMessage } = (0, $2fb3b93ec1994bc7$export$9949bd9c713ba425)();
    (0, $2e682f50ad48c6fc$export$6d9c69b0de29b591)(async ()=>{
        if (userStore.loading) return;
        userStore.loading = true;
        const userSession = await (0, $e111026c1c9a385d$export$6c39a76dc399236a)();
        if (userSession.error === true && userSession.status !== 401) setMessage(`Failed to load profile data - ${userSession.message}`, 'error');
        else {
            if (userSession.username === undefined) ;
            else login(userSession);
        }
    });
    // eventually we may want to fetch the snoo avatar, for now, don't
    // useEffect(() => {
    // 	useEffect(async () => {
    // 		const account = await fetch('https://www.reddit.com/user/jrjurman/about.json');
    // 		const accountData = await account.json();
    // 		console.log(accountData);
    // 	});
    // })
    const login = ({ id: id, username: username, account_type: account_type, key_limit: key_limit })=>{
        userStore.loggedIn = true;
        // TODO process login data
        userStore.id = id;
        userStore.username = username;
        userStore.accountType = account_type;
        userStore.keyLimit = key_limit;
    };
    const logout = ()=>{
        userStore.loggedIn = false;
        userStore.id = null;
        userStore.username = '';
        userStore.accountType = '';
        userStore.keyLimit = 0;
        window.location.href = '/logout';
    };
    const isLoggedIn = ()=>{
        return userStore.loggedIn;
    };
    const getUserName = ()=>{
        return userStore.username;
    };
    const getKeyLimit = ()=>{
        return userStore.keyLimit;
    };
    const getAccountType = ()=>{
        return userStore.accountType;
    };
    return {
        login: login,
        logout: logout,
        isLoggedIn: isLoggedIn,
        getUserName: getUserName,
        getKeyLimit: getKeyLimit,
        getAccountType: getAccountType
    };
};


const $97e4216334b9944f$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)();
const $97e4216334b9944f$var$UserMenu = ()=>{
    const { getUserName: getUserName, isLoggedIn: isLoggedIn, logout: logout, getAccountType: getAccountType } = (0, $17ea58b1aa86ae1d$export$23bbbc4533528f03)();
    if (!isLoggedIn()) return $97e4216334b9944f$var$html`<section />`;
    const userName = getUserName();
    const onSelect = (event)=>{
        if (event.target.value === 'logout') logout();
        else if (event.target.value === 'admin-dashboard') window.open('/admin');
        else if (event.target.value === 'subnotifications') window.open('https://www.reddit.com/r/SubNotifications/');
        event.target.value = 'username';
    };
    const accountType = getAccountType();
    const isAdminAccount = accountType === 'admin';
    const adminDashOption = isAdminAccount ? $97e4216334b9944f$var$html`<option value="admin-dashboard">Admin Dashboard</option>` : '';
    return $97e4216334b9944f$var$html`
		<select class="UserControl" title="account controls" onchange=${onSelect}>
			<option value="username" class="user-control-username">${userName}</option>
			${adminDashOption}
			<option value="subnotifications">r/SubNotifications</option>
			<option value="logout">Log out</option>
		</select>
	`;
};
var $97e4216334b9944f$export$2e2bcd8739ae039 = $97e4216334b9944f$var$UserMenu;


var $f557099f24518073$exports = {};
$f557099f24518073$exports = import.meta.resolve("aFss7");


// const svgFullLogoPath = '../../assets/redditcomber-FULL/color/SVG/redditcomber_FULL-color.svg';
// const resolvedPath = new URL(svgFullLogoPath, import.meta.url);
const $0d0769f1ac61fd13$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)({
    UserControl: $97e4216334b9944f$export$2e2bcd8739ae039
});
const $0d0769f1ac61fd13$var$AppHeader = ()=>{
    return $0d0769f1ac61fd13$var$html`
		<header class="AppHeader">
			<section class="app-header-content">
				<a href="/">
					<h1 class="app-title">
						<img class="logo" src="${0, (/*@__PURE__*/$parcel$interopDefault($f557099f24518073$exports))}" width="300px" alt="RedditComber logo" title="RedditComber" />
					</h1>
				</a>
				<UserControl />
			</section>
		</header>
	`;
};
var $0d0769f1ac61fd13$export$2e2bcd8739ae039 = $0d0769f1ac61fd13$var$AppHeader;






const $7b6364a8ec83aac7$var$svg = (0, $2e682f50ad48c6fc$export$cf400134d4350689)();
const $7b6364a8ec83aac7$var$XSvg = ()=>{
    return $7b6364a8ec83aac7$var$svg`
		<svg class="XSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
			<path d="M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z">
			</path>
		</svg>
	`;
};
var $7b6364a8ec83aac7$export$2e2bcd8739ae039 = $7b6364a8ec83aac7$var$XSvg;


const $9bcfba0921bc00b6$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)({
    XSvg: $7b6364a8ec83aac7$export$2e2bcd8739ae039
});
const $9bcfba0921bc00b6$var$XControl = ({ onselect: onselect, onhover: onhover })=>{
    const startDismissing = ()=>{
        onhover && onhover(true);
    };
    const endDismissing = ()=>{
        onhover && onhover(false);
    };
    return $9bcfba0921bc00b6$var$html`
		<button class="XControl" onclick=${onselect} onmouseenter=${startDismissing} onmouseleave=${endDismissing}>
			<XSvg />
		</button>
	`;
};
var $9bcfba0921bc00b6$export$2e2bcd8739ae039 = $9bcfba0921bc00b6$var$XControl;


const $dc09e67e809a9bf0$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)({
    XControl: $9bcfba0921bc00b6$export$2e2bcd8739ae039
});
const $dc09e67e809a9bf0$var$NotificationBanner = ()=>{
    const { getNotificationMessage: getNotificationMessage, dismissNotification: dismissNotification } = (0, $2fb3b93ec1994bc7$export$9949bd9c713ba425)();
    const { message: message, type: type, visible: visible } = getNotificationMessage();
    const onDismissNotification = ()=>{
        dismissNotification();
    };
    if (!visible) return $dc09e67e809a9bf0$var$html` <section class="NotificationBanner"></section>`;
    return $dc09e67e809a9bf0$var$html` <section class="NotificationBanner notification-${type}">
		<a>${message}</a>
		<XControl onselect=${onDismissNotification} />
	</section>`;
};
var $dc09e67e809a9bf0$export$2e2bcd8739ae039 = $dc09e67e809a9bf0$var$NotificationBanner;







const $04c55e36d3299cde$var$defaultFilters = (keyword)=>({
        key: keyword,
        source: 'both',
        subreddits: {
            type: 'blacklist',
            values: new Set()
        },
        users: {
            type: 'blacklist',
            values: new Set()
        },
        dirty: true
    });
const $04c55e36d3299cde$var$blankKeywordStore = ()=>({});
const $04c55e36d3299cde$var$defaultSelectedKeywordStore = {
    selected: null
};
const $04c55e36d3299cde$export$973ca22476b0e05f = (category)=>{
    const keywordStore = (0, $2e682f50ad48c6fc$export$ea7f481060e2c12e)('KEYWORD_STORE', $04c55e36d3299cde$var$blankKeywordStore());
    const savedKeywordStore = (0, $2e682f50ad48c6fc$export$ea7f481060e2c12e)('SAVED_KEYWORD_STORE', $04c55e36d3299cde$var$blankKeywordStore());
    const selectedKeywordStore = (0, $2e682f50ad48c6fc$export$ea7f481060e2c12e)('SELECTED_KEYWORD_STORE', $04c55e36d3299cde$var$defaultSelectedKeywordStore);
    const keyword = selectedKeywordStore.selected;
    const setType = (newType)=>{
        keywordStore[keyword][category].type = newType;
        keywordStore[keyword].dirty = true;
    };
    const getType = ()=>{
        if (keyword == null) return null;
        return keywordStore[keyword][category].type;
    };
    const getSavedType = ()=>{
        if (keyword == null || savedKeywordStore[keyword] == null) return null;
        return savedKeywordStore[keyword][category].type;
    };
    const addValue = (newValue)=>{
        keywordStore[keyword][category].values.add(newValue);
        keywordStore[keyword].dirty = true;
    };
    const removeValue = (valueToRemove)=>{
        keywordStore[keyword][category].values.delete(valueToRemove);
        keywordStore[keyword].dirty = true;
    };
    const getValues = ()=>{
        if (keyword == null) return [];
        return keywordStore[keyword][category].values;
    };
    const getSavedValues = ()=>{
        if (keyword == null || savedKeywordStore[keyword] == null) return [];
        return savedKeywordStore[keyword][category].values;
    };
    const getPrefix = ()=>{
        return category === 'subreddits' ? 'r/' : 'u/';
    };
    return {
        setType: setType,
        getType: getType,
        addValue: addValue,
        getValues: getValues,
        getPrefix: getPrefix,
        removeValue: removeValue,
        getSavedType: getSavedType,
        getSavedValues: getSavedValues
    };
};
const $04c55e36d3299cde$export$26883b0af8f2881e = ()=>{
    const keywordStore = (0, $2e682f50ad48c6fc$export$ea7f481060e2c12e)('KEYWORD_STORE', $04c55e36d3299cde$var$blankKeywordStore());
    const savedKeywordStore = (0, $2e682f50ad48c6fc$export$ea7f481060e2c12e)('SAVED_KEYWORD_STORE', $04c55e36d3299cde$var$blankKeywordStore());
    const keywordStoreFetch = (0, $2e682f50ad48c6fc$export$ea7f481060e2c12e)('KEYWORD_STORE_FETCH', {
        isLoading: false
    });
    const selectedKeywordStore = (0, $2e682f50ad48c6fc$export$ea7f481060e2c12e)('SELECTED_KEYWORD_STORE', $04c55e36d3299cde$var$defaultSelectedKeywordStore);
    const { setMessage: setMessage } = (0, $2fb3b93ec1994bc7$export$9949bd9c713ba425)();
    (0, $2e682f50ad48c6fc$export$6d9c69b0de29b591)(async ()=>{
        if (keywordStoreFetch.isLoading) return;
        keywordStoreFetch.isLoading = true;
        const fetchedKeywords = await (0, $e111026c1c9a385d$export$83628895f1965282)();
        if (fetchedKeywords.error) setMessage(`Failed to fetch keywords - ${fetchedKeywords.message}`, 'error');
        else loadFetchedKeywords(fetchedKeywords.data);
    });
    const loadFetchedKeywords = (fetchedKeywords)=>{
        Object.keys(fetchedKeywords).forEach((keyword)=>{
            copyKeyword(keyword, keywordStore, fetchedKeywords);
            copyKeyword(keyword, savedKeywordStore, fetchedKeywords);
        });
        // if we have any keywords, by default select the first one
        if (Object.keys(fetchedKeywords).length > 0) selectKeyword(Object.keys(fetchedKeywords)[0]);
    };
    const getKeywords = ()=>{
        return Object.keys(keywordStore);
    };
    const getSelectedKeyword = ()=>{
        return selectedKeywordStore.selected;
    };
    const selectKeyword = (keywordToSelect)=>{
        selectedKeywordStore.selected = keywordToSelect;
    };
    const addKeyword = (newKeyword)=>{
        // format keyword in all the sane ways (trim whitespace)
        const formattedKeyword = newKeyword.trim();
        // if keyword is blank, don't write it
        if (formattedKeyword === '') return;
        // if keyword already exists, don't reset it
        if (keywordStore[formattedKeyword] !== undefined) return;
        keywordStore[formattedKeyword] = $04c55e36d3299cde$var$defaultFilters(newKeyword);
        selectKeyword(formattedKeyword);
    };
    const removeKeyword = async (keywordToRemove)=>{
        const keywordIsOnServer = keywordStore[keywordToRemove].id;
        if (keywordIsOnServer) {
            const removeResponse = await (0, $e111026c1c9a385d$export$f5b865e5421e10a3)(keywordStore[keywordToRemove]);
            if (removeResponse.error) {
                setMessage(`Failed to remove keyword - ${removeResponse.message}`, 'error');
                return;
            } else setMessage(`Successfully removed keyword`, 'success');
        }
        if (selectedKeywordStore.selected === keywordToRemove) // if the keyword we want to remove is the selected one,
        selectKeyword(null);
        delete keywordStore[`${keywordToRemove}`];
    };
    const isDirty = (keyword)=>{
        if (keywordStore[keyword] === undefined) return false;
        return keywordStore[keyword].dirty;
    };
    const setSource = (keyword, newSource)=>{
        keywordStore[keyword].source = newSource;
        keywordStore[keyword].dirty = true;
    };
    const getSource = (keyword)=>{
        return keywordStore[keyword].source;
    };
    const getSavedSource = (keyword)=>{
        if (keyword == null || savedKeywordStore[keyword] == null) return null;
        return savedKeywordStore[keyword].source;
    };
    const copyKeyword = (keyword, store, referenceStore)=>{
        // if we are removing the keyword, then just delete it
        if (referenceStore[keyword] == null) {
            removeKeyword(keyword);
            return;
        }
        // otherwise copy all the properties over
        store[keyword] = $04c55e36d3299cde$var$defaultFilters(keyword);
        store[keyword].id = referenceStore[keyword].id;
        store[keyword].key = referenceStore[keyword].key;
        store[keyword].source = referenceStore[keyword].source;
        store[keyword].subreddits.type = referenceStore[keyword].subreddits.type;
        store[keyword].subreddits.values = new Set([
            ...referenceStore[keyword].subreddits.values
        ]);
        store[keyword].users.type = referenceStore[keyword].users.type;
        store[keyword].users.values = new Set([
            ...referenceStore[keyword].users.values
        ]);
        store[keyword].dirty = false;
        referenceStore[keyword].dirty = false;
    };
    const saveKeyword = async (keyword)=>{
        if (keywordStore[keyword].id) {
            // if there is an id, we want to update the keyword
            const keywordResponse = await (0, $e111026c1c9a385d$export$1268a3b77d58fa65)(keywordStore[keyword]);
            if (keywordResponse.error) {
                setMessage(`Failed to update keyword - ${keywordResponse.message}`, 'error');
                return;
            } else setMessage('Successfully updated keyword', 'success');
        } else {
            // if there is no id, we need to create the keyword
            const keywordResponse = await (0, $e111026c1c9a385d$export$48514181e03470c)(keywordStore[keyword]);
            if (keywordResponse.error) {
                setMessage(`Failed to create keyword - ${keywordResponse.message}`, 'error');
                return;
            } else setMessage('Successfully added keyword', 'success');
            keywordStore[keyword].id = keywordResponse.id;
        }
        copyKeyword(keyword, savedKeywordStore, keywordStore);
    };
    const resetKeyword = (keyword)=>{
        copyKeyword(keyword, keywordStore, savedKeywordStore);
    };
    return {
        getKeywords: getKeywords,
        selectKeyword: selectKeyword,
        getSelectedKeyword: getSelectedKeyword,
        addKeyword: addKeyword,
        removeKeyword: removeKeyword,
        isDirty: isDirty,
        saveKeyword: saveKeyword,
        resetKeyword: resetKeyword,
        setSource: setSource,
        getSource: getSource,
        getSavedSource: getSavedSource
    };
};






const $ab88a585aedb78ba$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)();
const $ab88a585aedb78ba$var$generateInputLabel = (category, filterType)=>{
    const categoryName = category === 'subreddits' ? 'subreddit' : 'user';
    const filterTypeAdjective = filterType === 'whitelist' ? 'only' : 'not';
    const oppositeCategory = category === 'subreddits' ? 'users' : 'subreddits';
    const categoryPhrase = category === 'subreddits' ? 'in subreddits' : 'by users';
    const filterTypeTooltip = `You will ${filterTypeAdjective} be notified by posts ${categoryPhrase} added here. This is in addition to any filters set for ${oppositeCategory}.`;
    const filterLabel = filterType === 'whitelist' ? 'Allow List' : 'Block List';
    return $ab88a585aedb78ba$var$html`
		<span>
			Add ${categoryName} to
			<span class="filter-type-label" title=${filterTypeTooltip}>${filterLabel}</span>
		</span>
	`;
};
const $ab88a585aedb78ba$var$FilterForm = ({ category: category, filterType: filterType })=>{
    const { addValue: addValue, getPrefix: getPrefix } = (0, $04c55e36d3299cde$export$973ca22476b0e05f)(category);
    const inputKey = `filter-input-${category}`;
    const label = $ab88a585aedb78ba$var$generateInputLabel(category, filterType);
    const onAddValue = (event)=>{
        event.preventDefault();
        addValue(event.target[inputKey].value);
        event.target[inputKey].value = '';
    };
    return $ab88a585aedb78ba$var$html`
		<form class="FilterForm" onsubmit=${onAddValue}>
			<label for=${inputKey}>${label}</label><br />
			<span class="filter-input-section">
				<span class="filter-input-prefix">${getPrefix()}</span>
				<input id=${inputKey} class="filter-input" />
			</span>
		</form>
	`;
};
var $ab88a585aedb78ba$export$2e2bcd8739ae039 = $ab88a585aedb78ba$var$FilterForm;






const $792180fc2f0f5a5d$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)({
    XControl: $9bcfba0921bc00b6$export$2e2bcd8739ae039
});
const $792180fc2f0f5a5d$var$FilterTag = ({ category: category, value: value, highlight: highlight })=>{
    const { getPrefix: getPrefix, getType: getType, removeValue: removeValue } = (0, $04c55e36d3299cde$export$973ca22476b0e05f)(category);
    const onRemoveSelected = ()=>{
        removeValue(value);
    };
    const highlightClass = highlight ? 'highlighted-tag' : 'tag';
    return $792180fc2f0f5a5d$var$html`
		<span class="FilterTag ${highlightClass} ${getType()}-${highlightClass}">
			${getPrefix()}${value}
			<XControl onselect=${onRemoveSelected} />
		</span>
	`;
};
var $792180fc2f0f5a5d$export$2e2bcd8739ae039 = $792180fc2f0f5a5d$var$FilterTag;



const $9c9205763cd565c4$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)({
    FilterTag: $792180fc2f0f5a5d$export$2e2bcd8739ae039
});
const $9c9205763cd565c4$var$FilterTags = ({ category: category })=>{
    const { getValues: getValues, getSavedValues: getSavedValues } = (0, $04c55e36d3299cde$export$973ca22476b0e05f)(category);
    const filterTags = [
        ...getValues()
    ].map((filterValue)=>{
        const shouldHighlight = !getSavedValues().has(filterValue);
        return $9c9205763cd565c4$var$html`<FilterTag category=${category} value=${filterValue} ${shouldHighlight ? 'highlight' : ''} />`;
    });
    return $9c9205763cd565c4$var$html`<section class="FilterTags">${filterTags}</section>`;
};
var $9c9205763cd565c4$export$2e2bcd8739ae039 = $9c9205763cd565c4$var$FilterTags;


const $be37b7dff1304d61$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)({
    FilterForm: $ab88a585aedb78ba$export$2e2bcd8739ae039,
    FilterTags: $9c9205763cd565c4$export$2e2bcd8739ae039
});
const $be37b7dff1304d61$var$FilterGroup = ({ category: category })=>{
    const { setType: setType, getType: getType, getSavedType: getSavedType } = (0, $04c55e36d3299cde$export$973ca22476b0e05f)(category);
    const setFilterType = (event)=>{
        setType(event.target.value);
    };
    const changed = getType() !== getSavedType();
    const highlightClass = changed ? 'highlight' : '';
    return $be37b7dff1304d61$var$html`
		<section class="FilterGroup">
			<h3 class="filter-header-and-type ${highlightClass}">
				<span class="filter-control-header">${category}</span>
				<select class="filter-type-dropdown" name="filter-type" onchange=${setFilterType}>
					<option ${getType() == 'blacklist' ? 'selected' : ''} value="blacklist">Block List</option>
					<option ${getType() == 'whitelist' ? 'selected' : ''} value="whitelist">Allow List</option>
				</select>
			</h3>
			<FilterForm category=${category} filterType=${getType()} />
			<FilterTags category=${category} />
		</section>
	`;
};
var $be37b7dff1304d61$export$2e2bcd8739ae039 = $be37b7dff1304d61$var$FilterGroup;




const $e15d05b26a3bf899$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)();
const $e15d05b26a3bf899$var$FilterSaveControls = ()=>{
    const { getSelectedKeyword: getSelectedKeyword, saveKeyword: saveKeyword, resetKeyword: resetKeyword, isDirty: isDirty } = (0, $04c55e36d3299cde$export$26883b0af8f2881e)();
    if (getSelectedKeyword() === null) return $e15d05b26a3bf899$var$html`<div />`;
    const onSaveKeyword = ()=>{
        const keyword = getSelectedKeyword();
        saveKeyword(keyword);
    };
    const onResetKeyword = ()=>{
        const keyword = getSelectedKeyword();
        resetKeyword(keyword);
    };
    const shouldDisplaySaveControls = isDirty(getSelectedKeyword());
    const displaySaveControlsClass = shouldDisplaySaveControls ? 'hideable' : 'hidden';
    return $e15d05b26a3bf899$var$html`
		<section class="FilterSaveControls ${displaySaveControlsClass}">
			<button
				class="reset-control keyword-control"
				onclick=${onResetKeyword}
				${!shouldDisplaySaveControls ? 'disabled' : ''}
			>
				Undo
			</button>
			<button
				class="save-control keyword-control"
				onclick=${onSaveKeyword}
				${!shouldDisplaySaveControls ? 'disabled' : ''}
			>
				Save
			</button>
		</section>
	`;
};
var $e15d05b26a3bf899$export$2e2bcd8739ae039 = $e15d05b26a3bf899$var$FilterSaveControls;




const $8e99a181caa7b946$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)();
const $8e99a181caa7b946$var$FilterRemoveControls = ()=>{
    const removingState = (0, $2e682f50ad48c6fc$export$6ccbb43953eebf8)({
        isRemoving: false
    });
    const { getSelectedKeyword: getSelectedKeyword, removeKeyword: removeKeyword } = (0, $04c55e36d3299cde$export$26883b0af8f2881e)();
    if (getSelectedKeyword() === null) return $8e99a181caa7b946$var$html`<div />`;
    const onSetRemoving = ()=>{
        removingState.isRemoving = true;
    };
    const onCancelRemoving = ()=>{
        removingState.isRemoving = false;
    };
    const onRemoveKeyword = ()=>{
        const keyword = getSelectedKeyword();
        removeKeyword(keyword);
    };
    return removingState.isRemoving ? $8e99a181caa7b946$var$html`
				<section class="FilterRemoveControls">
					Are you sure you want to remove this keyword?
					<button class="remove-cancel keyword-control" onclick=${onCancelRemoving}>Cancel</button>
					<button class="remove-confirm keyword-control" onclick=${onRemoveKeyword}>Confirm</button>
				</section>
			` : $8e99a181caa7b946$var$html`
				<section class="FilterRemoveControls">
					<button class="remove-start keyword-control" onclick=${onSetRemoving}>Remove Keyword</button>
				</section>
			`;
};
var $8e99a181caa7b946$export$2e2bcd8739ae039 = $8e99a181caa7b946$var$FilterRemoveControls;




const $93b7674d40c762ae$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)();
const $93b7674d40c762ae$var$sourceValues = [
    {
        value: 'both',
        label: 'Posts and Comments'
    },
    {
        value: 'posts',
        label: 'Posts only'
    },
    {
        value: 'comments',
        label: 'Comments only'
    }
];
const $93b7674d40c762ae$var$FilterNotificationsControl = ({ category: category })=>{
    const { getSelectedKeyword: getSelectedKeyword, getSource: getSource, setSource: setSource, getSavedSource: getSavedSource } = (0, $04c55e36d3299cde$export$26883b0af8f2881e)();
    if (getSelectedKeyword() === null || getSelectedKeyword() === undefined) return $93b7674d40c762ae$var$html`<div />`;
    const currentSourceValue = getSource(getSelectedKeyword());
    const sourceOptions = $93b7674d40c762ae$var$sourceValues.map(({ value: value, label: label })=>{
        return $93b7674d40c762ae$var$html`<option ${currentSourceValue === value ? 'selected' : ''} value=${value}>${label}</option>`;
    });
    const savedSourceValue = getSavedSource(getSelectedKeyword());
    const shouldHighlight = savedSourceValue !== currentSourceValue;
    const onSelectSource = (event)=>{
        const newSource = event.target.value;
        setSource(getSelectedKeyword(), newSource);
    };
    return $93b7674d40c762ae$var$html`
		<section class="FilterNotificationsControl">
			<h3 class="${shouldHighlight ? 'highlight' : ''}">
				<span class="filter-control-header">Notifications for</span>
				<select class="filter-type-dropdown" onchange=${onSelectSource}>
					${sourceOptions}
				</select>
			</h3>
		</section>
	`;
};
var $93b7674d40c762ae$export$2e2bcd8739ae039 = $93b7674d40c762ae$var$FilterNotificationsControl;


const $a9b21a01b7973100$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)({
    FilterGroup: $be37b7dff1304d61$export$2e2bcd8739ae039,
    FilterSaveControls: $e15d05b26a3bf899$export$2e2bcd8739ae039,
    FilterRemoveControls: $8e99a181caa7b946$export$2e2bcd8739ae039,
    FilterNotificationsControl: $93b7674d40c762ae$export$2e2bcd8739ae039
});
const $a9b21a01b7973100$var$FilterSection = ()=>{
    const { getSelectedKeyword: getSelectedKeyword } = (0, $04c55e36d3299cde$export$26883b0af8f2881e)();
    if (getSelectedKeyword() === null) return $a9b21a01b7973100$var$html`<h2>Create or Select a Keyword</h2>`;
    const keyword = getSelectedKeyword();
    return $a9b21a01b7973100$var$html`
		<section class="FilterSection">
			<h2 class="filter-section-header">
				Filters for "${keyword}"
				<FilterSaveControls />
			</h2>

			<FilterNotificationsControl />
			<FilterGroup category="subreddits" />
			<FilterGroup category="users" />
			<FilterRemoveControls keyword="${keyword}" />
		</section>
	`;
};
var $a9b21a01b7973100$export$2e2bcd8739ae039 = $a9b21a01b7973100$var$FilterSection;





const $12c9b4359cc38061$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)();
const $12c9b4359cc38061$var$KeywordForm = ()=>{
    const workingKeyword = (0, $2e682f50ad48c6fc$export$6ccbb43953eebf8)({
        value: '',
        hasCapitals: false
    });
    const { addKeyword: addKeyword } = (0, $04c55e36d3299cde$export$26883b0af8f2881e)();
    const onTypingKeyword = (event)=>{
        const inputElement = event.target;
        workingKeyword.value = inputElement.value;
        workingKeyword.hasCapitals = !!inputElement.value.match(/[A-Z]/);
    };
    const onAddingKeyword = (event)=>{
        event.preventDefault();
        workingKeyword.value = '';
        workingKeyword.hasCapitals = false;
        addKeyword(event.target['new-keyword-form'].value.toLowerCase());
    };
    const caseInsensitiveNote = workingKeyword.hasCapitals ? '*keywords are not case-sensitive' : '';
    return $12c9b4359cc38061$var$html`
		<form class="KeywordForm" onsubmit=${onAddingKeyword}>
			<input
				id="new-keyword-form"
				class="new-keyword-form"
				type="text"
				placeholder="add new keyword"
				onkeydown=${onTypingKeyword}
				value=${workingKeyword.value}
			/>
			<span class="new-keyword-note">${caseInsensitiveNote}</span>
		</form>
	`;
};
var $12c9b4359cc38061$export$2e2bcd8739ae039 = $12c9b4359cc38061$var$KeywordForm;




const $f4ee4d2c551b1af5$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)();
const $f4ee4d2c551b1af5$var$KeywordItem = ({ keyword: keyword, onselect: onselect })=>{
    const { getSelectedKeyword: getSelectedKeyword, isDirty: isDirty } = (0, $04c55e36d3299cde$export$26883b0af8f2881e)();
    const isSelectedKeywordClass = keyword == getSelectedKeyword() ? 'selected' : '';
    const keywordDirtyClass = isDirty(keyword) ? 'dirty' : '';
    return $f4ee4d2c551b1af5$var$html`
		<span class="KeywordItem ${isSelectedKeywordClass}">
			<button class="keyword-item-select ${keywordDirtyClass}" onclick=${onselect}>${keyword}</button>
		</span>
	`;
};
var $f4ee4d2c551b1af5$export$2e2bcd8739ae039 = $f4ee4d2c551b1af5$var$KeywordItem;




const $d5093213af2d2ea7$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)({
    KeywordForm: $12c9b4359cc38061$export$2e2bcd8739ae039,
    KeywordItem: $f4ee4d2c551b1af5$export$2e2bcd8739ae039
});
const $d5093213af2d2ea7$var$KeywordSection = ()=>{
    const { getKeyLimit: getKeyLimit } = (0, $17ea58b1aa86ae1d$export$23bbbc4533528f03)();
    const { getKeywords: getKeywords, selectKeyword: selectKeyword } = (0, $04c55e36d3299cde$export$26883b0af8f2881e)();
    const keywordItems = getKeywords().map((keyword)=>{
        const onSelectKeyword = ()=>{
            selectKeyword(keyword);
        };
        return $d5093213af2d2ea7$var$html`<KeywordItem onselect=${onSelectKeyword} keyword=${keyword} />`;
    });
    return $d5093213af2d2ea7$var$html`
		<section class="KeywordSection">
			<h2 class="keyword-header">
				Keywords
				<span class="keyword-limit-label">(${getKeywords().length}/${getKeyLimit()})</span>
			</h2>
			<section>${keywordItems}</section>
			<KeywordForm />
		</section>
	`;
};
var $d5093213af2d2ea7$export$2e2bcd8739ae039 = $d5093213af2d2ea7$var$KeywordSection;


const $ef48fb0b7ccc6768$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)({
    KeywordSection: $d5093213af2d2ea7$export$2e2bcd8739ae039,
    FilterSection: $a9b21a01b7973100$export$2e2bcd8739ae039
});
const $ef48fb0b7ccc6768$var$MainScreen = ()=>{
    return $ef48fb0b7ccc6768$var$html`
		<section class="MainScreen">
			<KeywordSection />
			<FilterSection />
		</section>
	`;
};
var $ef48fb0b7ccc6768$export$2e2bcd8739ae039 = $ef48fb0b7ccc6768$var$MainScreen;



var $7f7a88041ab0b2ac$exports = {};
$7f7a88041ab0b2ac$exports = import.meta.resolve("bVsSK");



const $71304ee1821c4b5e$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)();
const $71304ee1821c4b5e$var$LoginScreen = ()=>{
    const { login: login } = (0, $17ea58b1aa86ae1d$export$23bbbc4533528f03)();
    return $71304ee1821c4b5e$var$html`
		<section class="LoginScreen">
			<section>
				<h1 class="login-title">Don't miss a single mention!</h1>
				<p class="login-copy">
					Get realtime notifications whenever a phrase or word appears on Reddit. Scans both posts and comments, and
					delivers notifications straight to your Reddit inbox.
				</p>
				<a href="/auth/reddit/login"><button class="login-control">Login with Reddit</button></a>
			</section>
			<img
				class="login-graphic"
				src=${0, (/*@__PURE__*/$parcel$interopDefault($7f7a88041ab0b2ac$exports))}
				alt="reddit.com message inbox with messages from RedditComber"
				width="100%"
			/>
		</section>
	`;
};
var $71304ee1821c4b5e$export$2e2bcd8739ae039 = $71304ee1821c4b5e$var$LoginScreen;




const $b4e14b6b8da86996$var$html = (0, $2e682f50ad48c6fc$export$cd8b0dba543a4992)({
    AppHeader: $0d0769f1ac61fd13$export$2e2bcd8739ae039,
    NotificationBanner: $dc09e67e809a9bf0$export$2e2bcd8739ae039,
    MainScreen: $ef48fb0b7ccc6768$export$2e2bcd8739ae039,
    LoginScreen: $71304ee1821c4b5e$export$2e2bcd8739ae039
});
const $b4e14b6b8da86996$var$home = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $17ea58b1aa86ae1d$export$23bbbc4533528f03)();
    const content = isLoggedIn() ? $b4e14b6b8da86996$var$html`<MainScreen />` : $b4e14b6b8da86996$var$html` <LoginScreen />`;
    return $b4e14b6b8da86996$var$html`
		<main>
			<AppHeader />
			<NotificationBanner />
			${content}
		</main>
	`;
};
(0, $2e682f50ad48c6fc$export$b3571188c770cc5a)($b4e14b6b8da86996$var$home, '#app');


//# sourceMappingURL=ui.361afe2a.js.map
